{
  "recruiting": "Värbamine",
  "courses": "Kursused",
  "courses-page": {
    "title": "Kursused",
    "create": "Loo kursus",
    "edit": "Muuda kursust",
    "empty": "Kursuseid pole veel",
    "fields": {
      "title": "Pealkiri",
      "description": "Kirjeldus",
      "documents-count": "Dokumendid"
    },
    "headers": {
      "title": "Pealkiri",
      "description": "Kirjeldus",
      "documents": "Dokumendid",
      "actions": "Toimingud"
    },
    "dialog": {
      "title-label": "Pealkiri",
      "description-label": "Kirjeldus",
      "documents-label": "Dokumendid",
      "documents-placeholder": "Vali teadmusbaasi dokumendid",
      "save": "Salvesta",
      "cancel": "Tühista"
    },
    "messages": {
      "created": "Kursus loodud",
      "updated": "Kursus uuendatud",
      "deleted": "Kursus kustutatud",
      "error": "Midagi läks valesti"
    },
    "confirm-delete": "Kustutada see kursus? Seda ei saa tagasi võtta."
  },
  "ai-study-chat": "AI õpichat",
  "ai-study-chat-page": {
    "title": "AI õpichat",
    "new-conversation": "Uus vestlus",
    "empty-sidebar": "Vestlusi pole veel",
    "empty-thread": "Vali kursus või stsenaarium õppimise alustamiseks",
    "untitled": "Uus vestlus",
    "input-placeholder": "Kirjuta oma küsimus…",
    "send": "Saada",
    "typing": "Assistent kirjutab…",
    "sources": "Allikad ({count})",
    "sources-label": "Allikad",
    "score": "asjakohasus",
    "retry": "Proovi uuesti",
    "copy": "Kopeeri",
    "copied": "Kopeeritud",
    "failed": "Saatmine ebaõnnestus",
    "search-placeholder": "Otsi vestlusi",
    "search-empty": "Midagi ei leitud",
    "empty": {
      "heading": "Valmis sind õppima aitama",
      "subtitle": "Küsi kursuse materjalide kohta mida soovid — leian vastuse teadmusbaasist ja näitan allikaid."
    },
    "groups": {
      "today": "Täna",
      "yesterday": "Eile",
      "earlier": "Varasem"
    },
    "composer": {
      "context": "Kontekst:",
      "hint": "Vastused genereerib AI sinu materjalide põhjal · Enter saadab, Shift+Enter teeb reavahetuse"
    },
    "suggestions-fallback": [
      {
        "title": "Tee materjalidest kokkuvõte",
        "subtitle": "Põhipunktid"
      },
      {
        "title": "Koosta õppeplaan",
        "subtitle": "Kust alustada"
      },
      {
        "title": "Testi mind",
        "subtitle": "Kiire kontroll"
      },
      {
        "title": "Selgita lihtsalt",
        "subtitle": "Ilma žargoonita"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Analüüsi seda sessiooni", "subtitle": "Peamised järeldused" },
      { "title": "Mida tegin hästi?", "subtitle": "Minu tugevused" },
      { "title": "Kus läks valesti ja miks?", "subtitle": "Arengukohtad" },
      { "title": "Mida peaksin järgmises sessioonis parandama?", "subtitle": "Konkreetsed sammud" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Kuidas minu tulemused arenevad?", "subtitle": "Üle sessioonide" },
      { "title": "Minu tugevad ja nõrgad oskused", "subtitle": "Sessioonide hinnangutest" },
      { "title": "Millele peaksin keskenduma?", "subtitle": "Treeningprioriteet" },
      { "title": "Võrdle esimest ja viimast sessiooni", "subtitle": "Mis on paranenud" }
    ],
    "quota": {
      "remaining": "{count} sõnumit alles",
      "exhausted": "AI-vestluse sõnumid on otsas.",
      "unavailable": "AI-vestlus ei ole teie plaanis saadaval."
    },
    "new-dialog": {
      "title": "Uus vestlus",
      "subtitle": "Vali allikas, millest AI vastab",
      "search": "Otsi…",
      "search-empty": "Midagi ei leitud",
      "source-type": "Allikas",
      "source-course": "Kursus",
      "source-scenario": "Stsenaarium",
      "source-competency": "Kompetents",
      "pick-course": "Vali kursus",
      "pick-scenario": "Vali stsenaarium",
      "pick-competency": "Vali kompetents",
      "pick-target": "Kõik sessioonid või konkreetne sessioon",
      "all-games": "Kõik sessioonid — minu areng",
      "all-games-sub": "Tulemuste trend selle kompetentsi osas",
      "back": "Tagasi",
      "no-games": "Lõpetatud sessioone pole",
      "empty-competencies": "Lõpetatud sessioone veel pole",
      "empty-competencies-hint": "Lõpetage sessioon kompetentsiga stsenaariumi järgi — siia ilmub AI analüüs",
      "empty-courses": "Kursusi pole veel saadaval",
      "empty-scenarios": "Stsenaariume pole veel saadaval",
      "tag-game": "Sessioon",
      "start": "Alusta",
      "cancel": "Tühista"
    },
    "stage": {
      "searching": "Otsin sinu materjalidest…",
      "reading": "Loen allikaid…",
      "writing": "Kirjutan vastust…",
      "writing_sources": "Analüüsin {count} lõiku…",
      "summarizing_short": "Korrastan varasemat konteksti",
      "searching_short": "Otsin sinu materjale",
      "reading_short": "Loen allikaid",
      "writing_short": "Kirjutan vastust",
      "writing_sources_short": "Analüüsin {count} lõiku"
    },
    "errors": {
      "send": "Sõnumi saatmine ebaõnnestus. Palun proovi uuesti.",
      "quota": "Sõnumite limiit on täis.",
      "rate_limit": "Liiga palju päringuid. Palun oota minut ja proovi uuesti.",
      "provider_unsupported": "Teadmusbaasi vestlus ei ole teie organisatsiooni praeguse AI pakkujaga saadaval.",
      "generic": "Midagi läks valesti."
    }
  },
  "base_title": "The Reflection",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Lehekülge ei leitud ⚠️",
  "404_description": "Me ei leidnud lehte, mida otsisid.",
  "404_home": "Tagasi avalehele",
  "401_title": "Sul puudub juurdepääs! 🔐",
  "401_description": "Sul ei ole luba sellele lehele juurde pääseda. Mine avalehele.",
  "401_home": "Tagasi avalehele",
  "changes_saved": "Muudatused salvestatud",
  "coming_soon": "Varsti tulekul",
  " ": " ",
  "select_date_and_time": "Vali kuupäev ja kellaaeg",
  "select_date": "Vali kuupäev",
  "chat": "Vestlus",
  "menu": "Menüü",
  "games": "Sessioonid",
  "tours": "Tuurid",
  "library": "Mediakogu",
  "library-video": "Video",
  "library-scorm": "Kursused",
  "library-documents": "Dokumendid",
  "scenarios": "Stsenaariumid",
  "competencies": "Kompetentsid",
  "competencies-list": "Loend",
  "skills": "Oskused",
  "home": "Avaleht",
  "home_player": "Osaleja",
  "player": "Osaleja",
  "home_expert": "Ekspert",
  "reports-analytics-tours": "Tuurid",
  "reports": "Aruanded",
  "ranking": "Edetabel",
  "analytics": "Analüütika",
  "support": "Tugi",
  "users": "Kasutajad",
  "participants": "Osalejad",
  "departments": "Osakonnad",
  "positions": "Ametikohad",
  "user-custom-fields": "Kohandatud väljad",
  "administration": "Haldus",
  "ai-assistants": "AI-assistendid",
  "ai-profiles": "AI-profiilid",
  "ai-connectors": "AI-ühendused",
  "Audit logs": "Auditilogid",
  "organizations": "Organisatsioonid",
  "loading": "Laadimine...",
  "retry": "Proovi uuesti",
  "previous": "Eelmine",
  "next": "Järgmine",
  "save": "Salvesta",
  "copy": "Kopeeri",
  "copy_failed": "Automaatne kopeerimine ei õnnestunud. Valige tekst väljal ja kopeerige see käsitsi (Ctrl+C või ⌘C).",
  "confirm": "Kinnita",
  "suggest": "Paku",
  "generate": "Genereeri",
  "cancel": "Tühista",
  "close": "Sulge",
  "search": "Otsi...",
  "accept": "Nõustu",
  "propose": "Paku",
  "decline": "Keeldu",
  "send_request": "Saada päring",
  "assign": "Määra",
  "actions": " ",
  "evaluators": {
    "ai": "AI",
    "expert": "Ekspert",
    "player": "Osaleja",
    "manager": "Juht",
    "head": "Juht"
  },
  "statistics": {
    "date_from": "Alates",
    "date_to": "Kuni",
    "competence": "Kompetents",
    "evaluator": "Hindaja",
    "last_games_effectiveness": {
      "effectiveness": "Tõhusus",
      "title": "Tõhusus sessioonide lõikes"
    },
    "skill_trend": {
      "average_score": "Keskmine hinne",
      "game": "Sessioon",
      "score": "Hinne",
      "title": "Keskmine hinne kompetentside lõikes"
    },
    "player_competence_radar": {
      "title": "Kompetentside statistika",
      "top": "Top 10",
      "players_in_company": "Osalejad ettevõttes",
      "by_games": "Analüütika sessioonide järgi",
      "subtitle": "Üldstatistika sinule ja sinu ettevõttele",
      "filter": "Filter",
      "you": "Sina",
      "company": "Ettevõte",
      "average_score": "keskmine hinne",
      "skills_counted": "{counted} oskust {total}-st"
    }
  },
  "participant": {
    "upcoming_games": "Eelseisvad sessioonid",
    "for_rank_games": "Hindamist ootavad"
  },
  "roles": {
    "player": "Osaleja",
    "admin": "SuperAdmin (süsteem)",
    "scoped_admin": "Vanemadministraator",
    "observer": "Vaatleja",
    "captain": "Kapten",
    "expert": "Ekspert",
    "lead_expert": "Vanemekspert",
    "manager": "Juht",
    "support": "Tugi",
    "early_access": "Varajane ligipääs",
    "head": "Juht",
    "candidate": "Kandidaat"
  },
  "user-status": {
    "active": "Aktiivne",
    "inactive": "Mitteaktiivne",
    "pending": "Ootel"
  },
  "pagination": {
    "showing": "näitan",
    "to": "kuni",
    "of": "kokku",
    "entries": "kirjet"
  },
  "validator": {
    "required": "See väli on kohustuslik",
    "library": "Faili suurus peab olema alla 500 MB",
    "email": "E-posti väli peab olema kehtiv e-post",
    "password": "Väli peab sisaldama vähemalt üht suurt ja väikest tähte, erimärki ning numbrit (min 8 märki)",
    "confirm": "Parooli kinnitamine ei ühti",
    "at_least": "Väli peab sisaldama vähemalt",
    "items": "üksust",
    "number": "See väli peab olema täisarv",
    "is_odd": "See väli peab olema paarisarv",
    "number_between": "Sisesta arv vahemikus",
    "number_and": "ja",
    "date_range_required": "Vahemik on nõutav",
    "invalid_date_range": "Kehtetu vahemik",
    "invalid_date_format": "Vigane kuupäeva vorming",
    "start_date_after_end_date": "Alguskuupäev peab olema enne lõppkuupäeva",
    "max_180_days": "Maksimaalselt 180 päeva"
  },
  "user": {
    "menu": {
      "settings": "Seaded",
      "statistics": "Statistika",
      "logout": "Logi välja"
    }
  },
  "theme": {
    "system": "Süsteem",
    "light": "Hele",
    "dark": "Tume"
  },
  "error": {
    "default": "Vabandame, ilmnes viga. Meie spetsialistid on sellest juba teadlikud ja parandavad selle esimesel võimalusel.",
    "unauthorized": "Sinu seanss on aegunud.",
    "contact-support": "Vabandame, ilmnes viga. Palun võta ühendust tehnilise toega",
    "forbidden": "Juurdepääs keelatud"
  },
  "confirmation": {
    "sure": "Kas oled kindel, et soovid kirje kustutada?",
    "sure_return_to_time_scheduling": "Kas oled kindel, et soovid viia seansi tagasi algusaja kooskõlastamise etappi?",
    "sure_restore": "Kas oled kindel, et soovid kirje taastada?",
    "sure_mark_failed": "Märkida mäng ebaõnnestunuks ja kustutada jäädavalt kõik hinnangud ja osalejate protokollid?",
    "success": "Õnnestus!",
    "deleted": "Kustutatud",
    "failed_marked": "Mäng märgitud ebaõnnestunuks",
    "restored": "Taastatud",
    "cancel": "Tühistatud",
    "yes": "Jah",
    "no": "Ei"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Tere tulemast tagasi",
        "progress": "Sinu üldine edenemine",
        "stats": {
          "minutes": "Minutit seanssis",
          "effectiveness": "Tõhusus",
          "completed_games_count": "Edukad sessioonid",
          "total_games_count": "Seansse kokku"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Ettevõtte edetabel",
          "player": "Osaleja",
          "effectiveness": "Tõhusus"
        }
      }
    },
    "head": {
      "my_stats": "Minu statistika",
      "subordinates": "Minu alluvad",
      "subordinate_stats": "Alluva statistika",
      "select_subordinate": "Valige alluv statistika vaatamiseks",
      "no_subordinates": "Alluvaid pole määratud"
    }
  },
  "chat-page": {
    "last_game": "Viimane sessioon",
    "chats": "Vestlused",
    "no-chats": "Vestlusi ei leitud",
    "contacts": "Kontaktid",
    "choose": "Vali kontakt",
    "send": "Saada",
    "type": "Kirjuta oma sõnum...",
    "no-contacts": "Kontakte ei leitud",
    "search": "Otsi...",
    "start_conversation": "Alusta vestlust",
    "start_connecting": " Alusta suhtlemist, valides vasakult ühe kontakti"
  },
  "scenarios-page": {
    "title": "Pealkiri",
    "export-docx": "Export .docx",
    "copy_title": "Kopeeri stsenaarium",
    "generate_ai_title": "Loo stsenaarium AI-ga",
    "organization": "Ettevõte",
    "competence": "Kompetents",
    "actions": " ",
    "add": "Lisa stsenaarium",
    "ai-generate": "Loo AI-ga",
    "copy": "Kopeeri stsenaarium",
    "add_popup": "Lisa stsenaarium",
    "delete": "Kustuta stsenaarium",
    "edit": "Muuda stsenaariumi",
    "edit_popup": "Muuda stsenaariumi",
    "industries": [
      "Kiirtarbekaubad/Jaekaubandus",
      "Farmaatika",
      "Pangandus ja finantstehnoloogia",
      "Hotellid ja turism",
      "IT-ettevõtted/SaaS",
      "Restoraniäri/HoReCa",
      "E-kaubandus/Turukohad",
      "Tööstus/Industry 4.0",
      "Logistika ja T&L",
      "Telekom",
      "Haridus/EdTech",
      "Keemiatööstus",
      "Tarneahela halduse tarkvara",
      "Avalik sektor/Mittetulundusühingud"
    ],
    "case_types": [
      "Juhtimine ja inimeste juhtimine",
      "Värbamine ja personali hindamine",
      "Müük ja klienditeenindus",
      "Läbirääkimised ja mõju",
      "Konfliktijuhtimine",
      "Strateegia ja elluviimine"
    ],
    "cases": [
      [
        "SMART/OKR eesmärkide seadmine",
        "Arendava tagasiside andmine (SBI/COIN)",
        "Delegeerimine",
        "GROW coaching",
        "Tulemusvestlus",
        "Mentorlus"
      ],
      [
        "Kompetentsipõhine intervjuu (CBI)",
        "Hindamine/Hindamiskeskus",
        "Sisseelamisprogramm"
      ],
      [
        "Klassikaline toote/teenuse müük",
        "Vastuväidete käsitlemine",
        "Lisamüük/Ristmüük",
        "Kaebuste käsitlemine",
        "M-kanali müük"
      ],
      [
        "Sisemised eelarve/ressursside läbirääkimised",
        "Kliendi/tarnija leping",
        "Kriisiläbirääkimised"
      ],
      [
        "Meeskonna sisekonflikt",
        "Juhi-alluva konflikt",
        "Väärtuste/eetika konflikt"
      ],
      [
        "Projektide portfelli prioritiseerimine",
        "Muutuste juhtimine",
        "Riskianalüüs"
      ]
    ],
    "formats": [
      "1-1",
      "Meeskonnad"
    ],
    "labels": {
      "industry": "Tööstus",
      "case_type": "Juhtumi tüüp",
      "case": "Juhtum",
      "format": "Formaat",
      "duration": "Kestus (minutit)",
      "game_vs_ai": "Sessioon vs AI",
      "level": "Tase",
      "competence": "Kompetents",
      "description": "Stsenaariumi kirjeldus",
      "description_hint": "Kirjeldage soovi korral stsenaariumi, mida soovite genereerida (maksimaalselt 4000 tähemärki)"
    },
    "generating_in_progress": "Stsenaariumi genereerimine, palun oodake..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Tuur",
      "full_name": "Osaleja",
      "games_count": "Sessioonid",
      "team": "Meeskond",
      "export": "Ekspordi",
      "effectiveness": "Tõhusus"
    }
  },
  "report-filters": {
    "department": "Osakond",
    "position": "Ametikoht",
    "employee": "Töötaja",
    "scenario": "Stsenaarium",
    "competence": "Kompetents",
    "period": "Periood",
    "reset": "Lähtesta",
    "only-period-competence": "Arvesse lähevad ainult periood ja kompetents"
  },
  "competencies-page": {
    "title": "Pealkiri",
    "export-docx": "Export .docx",
    "skills": "Oskused",
    "text": "Tekst",
    "display_order": "Sorteerimine",
    "ai-assistant": "AI-assistent",
    "language": "Keel",
    "department": "Osakond",
    "evaluation-target": "Keda hindame?",
    "evaluation-both": "Mõlemad osalejad",
    "evaluation-team-a": "Ainult meeskond A",
    "evaluation-both-tooltip": "Hinnatakse mõlemat osalejat – sobib läbirääkimisstsenaariumitele",
    "evaluation-team-a-tooltip": "Hinnatakse ainult juhti – tagasiside formaat",
    "actions": " ",
    "add": "Lisa kompetents",
    "add_popup": "Lisa kompetents",
    "delete": "Kustuta kompetents",
    "edit": "Muuda kompetentsi",
    "edit_popup": "Muuda kompetentsi"
  },
  "faq-page": {
    "title": "Küsimused",
    "question": "Küsimus",
    "text": "Vastus",
    "is_shared": "Saadaval kõigile ettevõtetele",
    "actions": " ",
    "visibility": "Nähtavus",
    "visible_to_all": "Nähtav kõigile kasutajatele",
    "visible_to_managers": "Nähtav ainult juhtidele",
    "add": "Lisa küsimus",
    "add_popup": "Lisa küsimus",
    "delete": "Kustuta küsimus",
    "edit": "Muuda küsimust",
    "edit_popup": "Muuda küsimust"
  },
  "ai-connectors-page": {
    "title": "AI-ühendused",
    "is_shared": "Saadaval kõigile organisatsioonidele",
    "actions": " ",
    "add": "Lisa ühendus",
    "add_popup": "Lisa ühendus",
    "delete": "Kustuta ühendus",
    "edit": "Muuda ühendust",
    "edit_popup": "Muuda ühendust",
    "label": "Nimetus",
    "provider": "Pakkuja",
    "service": "Teenus",
    "status": "Olek",
    "region": "Piirkond",
    "endpoint": "Lõpp-punkt",
    "secret": "Parool/Võti",
    "maxConcurrency": "Maksimaalne samaaegne ühenduste arv",
    "timeoutSec": "Ajalõpp",
    "sortOrder": "Sorteerimisjärjestus",
    "config": "Konfiguratsioon",
    "modelPrimary": "Primary-mudel",
    "modelLight": "Light-mudel",
    "modelLightHint": "Tühi — light-päringud kasutavad primary-mudelit",
    "folderId": "Folderi ID",
    "models": "Mudelid",
    "is_default": "Default",
    "notes": "Märkmed"
  },
  "skills-page": {
    "title": "Pealkiri",
    "display_order": "Sorteerimine",
    "competence": "Kompetents",
    "text": "Näitajad",
    "actions": " ",
    "add": "Lisa oskus",
    "add_popup": "Lisa oskus",
    "delete": "Kustuta oskus",
    "edit": "Muuda oskust",
    "edit_popup": "Muuda oskust"
  },
  "departments-page": {
    "title": "Pealkiri",
    "actions": " ",
    "add": "Lisa osakond",
    "add_popup": "Lisa osakond",
    "delete": "Kustuta osakond",
    "edit": "Muuda osakonda",
    "edit_popup": "Muuda osakonda"
  },
  "tours-page": {
    "title": "Pealkiri",
    "actions": " ",
    "add": "Lisa tuur",
    "add_popup": "Lisa tuur",
    "delete": "Kustuta tuur",
    "edit": "Muuda tuuri",
    "edit_popup": "Muuda tuuri"
  },
  "library-page": {
    "title": "Pealkiri",
    "text": "Kirjeldus",
    "video": "Video",
    "courses": "Kursused",
    "video_link_copy": "Kopeeri link",
    "video_in_process": "Video on töötlemisel...",
    "is_public": "Avalik",
    "actions": " ",
    "add": "Lisa video",
    "add_popup": "Lisa video",
    "delete": "Kustuta video",
    "edit": "Muuda videot",
    "edit_popup": "Muuda videot"
  },
  "library-documents-page": {
    "title": "Pealkiri",
    "actions": " ",
    "add": "Lisa dokument",
    "add_popup": "Lisa dokument",
    "delete": "Kustuta dokument",
    "edit": "Muuda dokumenti",
    "edit_popup": "Muuda dokumenti",
    "file": "Fail"
  },
  "scorm-page": {
    "title": "Pealkiri",
    "actions": " ",
    "add": "Lisa kursus",
    "loading": "Kursus laaditakse...",
    "add_popup": "Lisa kursus",
    "delete": "Kustuta kursus",
    "edit": "Muuda kursust",
    "edit_popup": "Muuda kursust",
    "zip_file": "ZIP-fail"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Kirjeldus",
    "actions": " ",
    "add": "Lisa AI-assistent",
    "add_popup": "Lisa AI-assistent",
    "delete": "Kustuta AI-assistent",
    "edit": "Muuda AI-assistenti",
    "edit_popup": "Muuda AI-assistenti"
  },
  "ai-prompts-page": {
    "name": "Nimi",
    "content": "Sisu",
    "actions": " ",
    "add": "Lisa AI-viip",
    "add_popup": "Lisa AI-viip",
    "delete": "Kustuta AI-viip",
    "edit": "Muuda AI-viipa",
    "edit_popup": "Muuda AI-viipa",
    "key": "Slot-võti",
    "model": "Mudel",
    "updated_at": "Uuendatud",
    "custom": "Kohandatud",
    "description": "Kirjeldus",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Arutluspingutus",
    "reasoning_effort_default": "Vaikimisi",
    "required_placeholders": "Kohustuslikud muutujad (peavad sisus esinema)",
    "versions": "Versioonide ajalugu",
    "no_versions": "Versioone pole veel",
    "restore": "Taasta",
    "restore_confirm": "Taastada see versioon? Selle sisu saab praeguseks.",
    "restored": "Versioon taastatud",
    "current_version": "Praegune",
    "author": "Autor",
    "error": "Midagi läks valesti.",
    "tab_system": "Süsteem",
    "tab_custom": "Kohandatud",
    "system_hint": "Süsteemsed viibad on platvormi koodi poolt kasutusel. Neid ei saa kustutada, kuid nende sisu saab muuta.",
    "custom_hint": "Kohandatud viibad kinnitatakse kompetentside ja AI-profiilide külge hindamisviiba ülekirjutusena.",
    "model_from_code": "määratud koodiga",
    "model_from_code_hint": "Mudeli valib viipa kasutav kood; seda ei salvestata viiba enda sisse.",
    "used_by": "Kasutusel",
    "used_by_value": "Kompetentsid: {competencies}, AI-profiilid: {profiles}",
    "not_used": "Ei kasutata",
    "delete_blocked_hint": "Ei saa kustutada: viip on kasutusel ülekirjutusena. {usage}",
    "slot_description": {
      "game_eval_negotiation": "PvP-sessioonide AI-hinnang: läbirääkimised",
      "game_eval_feedback": "PvP-sessioonide AI-hinnang: tagasiside",
      "game_eval_vs_ai": "AI-hinnang sessioonidele vs AI (kui AI-profiilil ülekirjutust pole)",
      "protocol_evaluation": "Stsenaariumi protokolli täitmine AI-vastase sessiooni transkriptsiooni põhjal",
      "voice_agent": "Süsteemne viip häälagendile",
      "scenario_generation": "Stsenaariumi genereerimine kirjelduse põhjal",
      "scenario_card_update": "Stsenaariumi kaardi uuendamine AI-kirjelduse põhjal",
      "scenario_optimize": "Stsenaariumi AI-kirjelduse optimeerimine",
      "skill_report_analysis": "Oskuste aruanne: analüüsi samm",
      "skill_report_recommendations": "Oskuste aruanne: soovituste samm"
    }
  },
  "ai-profiles-page": {
    "name": "Nimi",
    "settings": "Seaded",
    "temperature": "Temperatuur",
    "demeanor": "Käitumislaad",
    "behavior": "Käitumine, juhised",
    "background": "Taust",
    "style": "Stiil",
    "instructions": "Juhised",
    "supportive_phrases": "Toetavad fraasid",
    "ai_assistant": "AI-assistent",
    "ai_starts_first": "AI alustab esimesena",
    "first_phrase": "Esimene fraas",
    "closing_phrases": "Lõpufraasid",
    "voice": "Hääl",
    "expert_mode": "Ekspertrežiim",
    "custom_demeanor_hint": "Praegune kohandatud käitumine",
    "is_shared": "Saadaval kõigile organisatsioonidele",
    "voice_options": {
      "male": "Mees",
      "female": "Naine"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Sõbralik",
        "description": "Kergesti ligipääsetav ja meeldiv"
      },
      "critical": {
        "title": "Kriitiline",
        "description": "Toob sageli esile puudusi ja parenduskohad"
      },
      "empathetic": {
        "title": "Empaatiline",
        "description": "Väga tundlik teiste tunnete ja emotsioonide suhtes"
      },
      "enthusiastic": {
        "title": "Entusiastlik",
        "description": "Näitab tugevat elevust ja innukust"
      },
      "analytical": {
        "title": "Analüütiline",
        "description": "Keskendub loogikale ja detailsele probleemilahendusele"
      },
      "curious": {
        "title": "Uudishimulik",
        "description": "Soovib õppida ja küsimusi esitada"
      },
      "assertive": {
        "title": "Enesekindel",
        "description": "Enesekindel ja otsusekindel suhtlus"
      },
      "blunt": {
        "title": "Otsekohene",
        "description": "Otsene ja asjalik"
      },
      "skeptical": {
        "title": "Skeptiline",
        "description": "Uute lahenduste ja ideede suhtes ettevaatlik"
      },
      "neutral": {
        "title": "Neutraalne",
        "description": "Tasakaalukas ja objektiivne suhtlusstiil"
      },
      "casual": {
        "title": "Mitteametlik",
        "description": "Lõdvestunud ja vestluslik toon"
      }
    },
    "placeholders": {
      "name": "Näiteks: Sergei (viisakas ja sõbralik)",
      "demeanor": "Näiteks: Sõbralik, viisakas ja seltsiv...",
      "background": "Näiteks: Vallandati kaks korda...",
      "behavior": "Näiteks: Ei sega vahele, kuulab aktiivselt...",
      "first_phrase": "Näiteks: Tere päevast! Kuidas tuju on?",
      "closing_phrases": "Näiteks: Aega on peaaegu otsas, teen ettepaneku kiiresti kohtumine kokku võtta."
    },
    "actions": " ",
    "add": "Lisa AI-profiil",
    "add_popup": "Lisa AI-profiil",
    "subtitle": "Kuidas vestluspartner sessioonis välja näeb ja kõlab",
    "preview": {
      "title": "Eelvaade",
      "unnamed": "Nimeta",
      "voice": "hääl {name}",
      "defaultVoice": "vaikehääl",
      "defaultPhoto": "Vaikefoto",
      "listen": "Kuula häält",
      "defaultVoiceNotice": "Hääl valitakse sessiooni alguses – eelnevalt kuulata ei saa",
      "photoPlaceholder": "Foto ilmub siia"
    },
    "delete": "Kustuta AI-profiil",
    "edit": "Muuda AI-profiili",
    "edit_popup": "Muuda AI-profiili",
    "avatar_hint": "avatari pilt",
    "avatar_save_first": "Avatari üleslaadimise lubamiseks salvestage esmalt profiil",
    "avatar_requirements": "Maks. 1 MB • Soovitatav: 1536×1024 • Kuvasuhe: 3:2",
    "max_characters": "Maksimaalselt {max} tähemärki"
  },
  "games-page": {
    "game-with-ai": "Rollisessioon AI-ga",
    "organization": "Organisatsioon",
    "status": "Staatus",
    "failure_reasons": {
        "protocol_not_agreed": "Osalejad ei jõudnud protokollis kokkuleppele",
        "protocol_approval_expired": "Protokolli kokkuleppimise aeg on lõppenud",
        "annulled": "Sessioon tühistati administraatori poolt",
        "expired": "Sessiooni aeg sai läbi",
        "assignment_changed": "Kursuse määramine õppesüsteemis muutus"
    },
    "restore": "Taasta",
    "play": "Mängi",
    "meetings_unavailable": "Osalejatevahelised videosessioonid on ajutiselt kättesaamatud. Proovi hiljem uuesti.",
    "import": "Impordi",
    "scenario": "Stsenaarium",
    "tour": "Tuur",
    "game_types": {
      "classic": "Klassikaline režiim",
      "vs_ai": "Rollisessioon AI-ga",
      "uploaded_recording": "Salvestis"
    },
    "upload_recording": {
      "file": "Salvestise fail",
      "file_hint": "Video või heli, kuni 1 GB",
      "uploaded": "Fail üles laaditud",
      "file_too_large": "Fail ületab 1 GB",
      "upload_error": "Faili üleslaadimine ebaõnnestus",
      "player": "Osaleja",
      "rate_both": "Hinda mõlemat osalejat",
      "second_player": "Teine osaleja",
      "open_session": "Ava sessioon"
    },
    "game_targets": {
      "user": "Osaleja",
      "position": "Ametikoht",
      "department": "Osakond"
    },
    "number": "Number",
    "start_up_to": "Alustada kuni",
    "start_time": "Algusaeg",
    "teamA": "Meeskond A",
    "teamB": "Meeskond B",
    "others": "Osalejad",
    "actions": " ",
    "edit_results": "Muuda tulemusi",
    "add": "Lisa sessioon",
    "add_popup": "Lisa sessioon",
    "delete": "Kustuta sessioon",
    "edit": "Muuda seansi",
    "edit_popup": "Muuda seansi",
    "time_scheduling": "Algusaja kooskõlastamine",
    "return_to_time_scheduling": "Tagasi algusaja kooskõlastamisele",
    "preparation": "Seansi ettevalmistus",
    "view_scenario": "Vaata stsenaariumi",
    "protocol": "Protokolli kinnitamine",
    "not_agreed": "Pole kokku lepitud",
    "expert-accept": "Nõustu ja liigu hindamisele",
    "expert-decline": "Keeldu",
    "hide_ai_results": "Peida AI hinnang",
    "show_ai_results": "Näita AI hinnangut",
    "mark_failed": "Märgi ebaõnnestunuks",
    "popup": {
      "start_up_to": "Alustada kuni",
      "target": "Kellele sessioon määrata?",
      "custom_field_value": "Välja „{field}“ väärtus",
      "target_preview_count": "Loodavaid sessioone: {count}",
      "target_preview_empty": "Ükski mängija ei vasta sellele valikule — ühtegi sessiooni ei looda",
      "target_preview_limit_exceeded": "See on rohkem, kui üks määramine luua saab (kuni {limit}). Vähendage valikut, juhtumite arvu või koopiate arvu",
      "copies_per_player": "Iga juhtumi koopiaid mängija kohta",
      "position": "Ametikoht",
      "department": "Osakond",
      "scenario": "Stsenaarium",
      "optional": "Valikuline, võib vahele jätta",
      "protocol_time": "Protokolli aeg",
      "protocol_time_hint": "Arv 1 kuni 1440",
      "preparation_time": "Ettevalmistusaeg",
      "preparation_time_hint": "Minutites",
      "game_duration": "Seansi kestus",
      "game_duration_hint": "Arv 1 kuni 60",
      "is_team": "Stsenaarium meeskondadele",
      "is_camera_required": "Osalejate kaamerad on kohustuslikud",
      "is_self_rated": "Osalejad saavad end ise hinnata",
      "is_each_other_rated": "Osalejad saavad üksteist hinnata",
      "is_expert_rated": "Eksperdi hinnang võimalik",
      "is_ai_rated": "AI hinnang võimalik",
      "show_results": "Tulemuste kuvamine",
      "automatically": "automaatselt",
      "manually": "käsitsi",
      "is_public_hint": "Iga vaatleja saab liituda",
      "is_public": "Avalik sessioon",
      "team_a": "Meeskond A",
      "team_b": "Meeskond B",
      "player_a": "Osaleja A",
      "player_b": "Osaleja B",
      "expert": "Ekspert",
      "observers": "Vaatlejad",
      "tour": "Tuur",
      "search": "Otsi...",
      "choose_players": "Vali osalejad",
      "choose_expert": "Vali ekspert",
      "choose_observers": "Vali vaatlejad",
      "choose_scenario": "Vali stsenaarium",
      "choose_tour": "Vali tuur",
      "expert_empty": "Kui pole valitud, saab kapten valida",
      "captain": "Kapten",
      "": "",
      "protocol": {
        "title": "Protokolli kinnitamine",
        "target": "Eesmärk",
        "await_approval": "Oota vastase kinnitust",
        "await_proposal": "Oota vastase ettepanekut",
        "questions": "Küsimused sinu meeskonnale",
        "questions_a": "Küsimused meeskonnale A",
        "questions_b": "Küsimused meeskonnale B",
        "not_agreed": "Ei jõutud kokkuleppele",
        "not_agreed_confirm": "Seanss lõpeb ebaõnnestunult ja tulemusi ei arvestata. See toiming on pöördumatu.",
        "not_agreed_done": "Seanss lõppes ebaõnnestunult."
      },
      "start_time": {
        "title": "Algusaeg",
        "must_start_by": "Peab algama hiljemalt"
      },
      "edit_results": {
        "title": "Muuda tulemusi"
      },
      "preparation": {
        "title": "Seansi ettevalmistus",
        "description": "Kirjeldus",
        "description_team": "Meeskonna kirjeldus",
        "notes": "Isiklikud märkmed"
      },
      "import": {
        "download_example": "Laadi näidis alla",
        "title": "Sessioonide import",
        "button": "Alusta importi",
        "label": "Exceli fail"
      },
      "create_multi_scenario_games_immediately": "Kõik sessioonid luuakse kohe",
      "create_multi_scenario_games_sequentially": "Sessioonid luuakse järjestikku (pärast iga edukat lõpetamist)"
    }
  },
  "ai-game": {
    "title": "Rollisessioon AI-ga",
    "recording": "Salvestamine",
    "ai": "AI",
    "you": "Sina",
    "ai_ready": "Valmis",
    "camera_off": "Kaamera on väljas",
    "stop_game": "Lõpeta sessioon",
    "start_game": "Alusta seansi",
    "mic_permission": "Seansi alustamiseks anna seadetes mikrofoniõigused",
    "permissions_granted": "Õigused on edukalt antud!",
    "close": "Sulge",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Lülitage mikrofon sisse, et seansi alustada",
    "mic_not_detected": "Heli pole veel tuvastatud — proovige rääkida või kontrollige mikrofoni",
    "permissions_needed": "Mikrofoni juurdepääs on kohustuslik. Kaamera on valikuline",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Kas oled kindel? Seansi ei saa pausile panna",
      "start_title": "Sessioon alustatud",
      "start_success": "Sessioon on edukalt alustatud",
      "start_cancel_title": "Seansi ei alustatud",
      "start_cancel_msg": "Seansi alustamine tühistati",
      "end_question": "Kas oled kindel? Sessioon lõpetatakse",
      "end_title": "Sessioon lõpetatud",
      "end_success": "Sessioon on edukalt lõpetatud",
      "end_cancel_title": "Seansi ei lõpetatud",
      "end_cancel_msg": "Seansi lõpetamine tühistati"
    },
    "voice": {
      "disconnected": "Ühendus katkestatud",
      "connecting": "Ühendamine...",
      "connected": "Ühendatud serveriga",
      "connection_error": "Ühendus häälagendiga ebaõnnestus",
      "game_already_finished": "See mäng on juba lõppenud",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Hetkel pole ühtegi tuba saadaval. Palun proovige hiljem uuesti.",
      "preparing_recording": "Salvestuse ettevalmistus, uus katse {seconds}s pärast…",
      "recording_service_overloaded": "Salvestusteenus on ülekoormatud. Palun proovige mõne minuti pärast uuesti.",
      "session_quota_exhausted": "Sinu organisatsiooni sessioonipakett on otsas. Palun pöördu oma juhi poole.",
      "connection_blocked": "Sinu võrk blokeeris AI-ühenduse loomise. Luba HTTPS (443) vajalikele domeenidele ja proovi uuesti.",
      "connection_blocked_signaling": "Sinu võrgu tulemüür või puhverserver blokeerib ühenduse häälserveriga. Proovi ühenduda teisest võrgust või mobiilse leviala kaudu.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "Kaamera või mikrofoni juurdepääs keelati. Mine Safari Settings > Websites > Camera/Microphone ja luba sellele saidile.",
    "supported": "Brauser toetatud"
  },
  "positions-page": {
    "title": "Pealkiri",
    "actions": " ",
    "add": "Lisa ametikoht",
    "add_popup": "Lisa ametikoht",
    "delete": "Kustuta ametikoht",
    "edit": "Muuda ametikohta",
    "edit_popup": "Muuda ametikohta"
  },
  "user-custom-fields-page": {
    "title": "Pealkiri",
    "type": "Tüüp",
    "options_count": "Väärtusi",
    "actions": " ",
    "add": "Lisa väli",
    "add_popup": "Lisa väli",
    "delete": "Kustuta väli",
    "delete_confirm": "Kas kustutada väli? Kasutajate juures salvestatud väärtusi enam ei kuvata.",
    "edit": "Muuda välja",
    "edit_popup": "Muuda välja",
    "empty": "Kohandatud välju veel pole",
    "error": "Välja salvestamine ebaõnnestus",
    "type_text": "Tekst",
    "type_select": "Loend",
    "type_locked_hint": "Pärast välja loomist ei saa selle tüüpi enam muuta",
    "options": "Väärtused",
    "options_hint": "Väärtuste järjekord siin on ka nende järjekord rippmenüüs",
    "options_required": "Lisage vähemalt üks väärtus",
    "option_title": "Väärtus",
    "option_add": "Lisa väärtus",
    "option_delete": "Kustuta väärtus",
    "option_delete_confirm": "Kas kustutada väärtus? Kasutajatel, kellel see oli valitud, väärtus tühjendatakse.",
    "option_move_up": "Liiguta üles",
    "option_move_down": "Liiguta alla"
  },
  "organizations-page": {
    "name": "Nimi",
    "host": "Host",
    "duel_limit": "Duellipiirang",
    "max_users": "Max kasutajad",
    "max_users_hint": "0 = piiramatu",
    "max_vs_ai_games_per_scenario": "Maks AI-mänge mängija kohta stsenaariumis",
    "max_vs_ai_games_per_scenario_hint": "Tühi = piiramatu. Kehtib mängija enda loodud mängude kohta",
    "employee_report_daily_limit": "Töötajate aruannete limiit päevas",
    "employee_report_daily_limit_hint": "Tühi = platvormiülene piirang. Kehtib juhtide kohta",
    "employee_report_hourly_limit": "Töötajate aruannete limiit tunnis",
    "employee_report_hourly_limit_hint": "Tühi = platvormiülene piirang. Kehtib juhtide kohta",
    "registration": "Registreerimine avatud",
    "timezone": "Ajavöönd",
    "locale": "Keel",
    "users_count": "Kasutajad",
    "actions": " ",
    "add": "Lisa organisatsioon",
    "add_popup": "Lisa organisatsioon",
    "delete": "Kustuta organisatsioon",
    "edit": "Muuda organisatsiooni",
    "edit_popup": "Muuda organisatsiooni",
    "available_languages": "Saadaolevad keeled",
    "show_game_numbers_for_player": "Näita sessiooninumbreid osalejale",
    "allow_players_choose_expert": "Luba osalejatel valida ekspert",
    "send_message": "Saada sõnum juhtidele",
    "message": "Sõnum",
    "send": "Saada",
    "clear_message": "Kustuta sõnum",
    "current_message": "Praegune sõnum",
    "two_factor_method": "Kahefaktoriline autentimine",
    "two_factor_disabled": "Keelatud",
    "two_factor_email": "E-post",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Peida AI tulemused",
    "hide_player_rating": "Peida ettevõtte edetabel osalejate eest",
    "show_character_memory_to_player": "Näita tegelase mälu mängijale",
    "show_meeting_recap_to_player": "Näita kohtumise kokkuvõtet mängijale",
    "create_user_on_external_launch": "Loo kasutaja välise süsteemi esimesel pöördumisel",
    "create_user_on_external_launch_hint": "Kui see on välja lülitatud, saab õppija, keda väline süsteem pole varem toonud, mängu asemel keeldumise. Iga sel viisil loodud kasutaja võtab tellimuses ühe koha.",
    "allow_external_email_linking": "Luba välise kasutaja sidumine e-posti järgi",
    "allow_external_email_linking_hint": "Kui see on sisse lülitatud, seotakse väline inimene juba olemasoleva töötajaga, kui väline süsteem edastas tema e-posti aadressi oma serverist. Kui see on välja lülitatud, selline käivitamine lükatakse tagasi ja sama aadressiga teist kasutajat ei looda."
  },
  "users-page": {
    "import": "Import",
    "user": "Kasutaja",
    "roles": "Rollid",
    "effectiveness": "Tõhusus",
    "department": "Osakond",
    "position": "Ametikoht",
    "status": "Staatus",
    "actions": " ",
    "add": "Lisa kasutaja",
    "add_popup": "Uus kasutaja",
    "last_login_at": "Viimane sisselogimine",
    "delete": "Kustuta",
    "view": "Vaata",
    "login": "Logi sisse",
    "message": "Sõnum",
    "activate": "Aktiveeri",
    "deactivate": "Blokeeri",
    "edit_popup": "Muuda kasutajat",
    "total_in_org": "Kokku organisatsioonis",
    "multi_role_note": "Mitme rolliga kasutaja on arvestatud igas sildis",
    "filter_role": "Roll",
    "all_roles": "Kõik rollid",
    "filter_activity": "Läbitud stsenaariumid",
    "activity_played": "Jah",
    "activity_not_played": "Ei",
    "filter_activity_from": "Läbitud alates",
    "filter_last_login_from": "Sisselogimise kuupäev",
    "filter_custom_field": "Kohandatud väli",
    "filter_custom_field_value": "Välja „{field}“ väärtus",
    "last_login_never": "Pole sisse logitud",
    "last_login_since": "Sisse logitud alates",
    "cases_progress": "Läbitud juhtumid",
    "cases_progress_value": "{completed} / {assigned}",
    "export": "Ekspordi",
    "popup": {
      "name": "Eesnimi",
      "last_name": "Perekonnanimi",
      "patronymic": "Isanimi",
      "phone": "Telefon",
      "timezone": "Ajavöönd",
      "language": "Keel",
      "country": "Riik",
      "invalid_phone": "Vale telefoninumber",
      "department": "Osakond",
      "position": "Ametikoht",
      "effectiveness": "Tõhusus",
      "roles": "Rollid",
      "organizations": "Organisatsioonid",
      "blocked": "Blokeeritud",
      "is_active": "Aktiivne",
      "email_verified": "E-post on kinnitatud",
      "email_not_verified": "E-post ei ole kinnitatud",
      "subordinates": "Alluvad",
      "search_subordinates": "Otsi osalejaid...",
      "import": {
        "download_example": "Laadi näidis alla",
        "title": "Kasutajate import",
        "button": "Alusta importi",
        "label": "Exceli fail",
        "marker_hint": "Juba olemasoleva kasutaja puhul jätab tühi lahter praeguse väärtuse alles ja kriips (-) tühjendab välja.",
        "result_title": "Import käivitatud",
        "result_created": "Luuakse: {count}",
        "result_updated": "Uuendatakse: {count}",
        "result_skipped": "Vahele jäetud: {count}",
        "result_skipped_row": "Rida {row}, {email}: {reason}",
        "result_truncated": "…ja veel {count} vahele jäetud rida"
      }
    }
  },
  "users-ranking-page": {
    "user": "Kasutaja",
    "roles": "Rollid",
    "effectiveness": "Tõhusus",
    "average-effectiveness": "Keskmine sessiooni kohta",
    "sessions-count": "Sessioonid",
    "department": "Osakond",
    "position": "Ametikoht",
    "status": "Staatus",
    "export": "Ekspordi",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Lõpetatud sessioonid",
    "not_found": "Kasutajat ei leitud",
    "games_total": "Kokku",
    "username": "Kasutajanimi",
    "phone": "Telefon",
    "status": "Staatus",
    "language": "Keel",
    "timezone": "Ajavöönd",
    "edit": "Muuda",
    "department": "Osakond",
    "position": "Ametikoht",
    "activate": "Aktiveeri",
    "block": "Blokeeri",
    "account": {
      "title": "Konto",
      "summary": {
        "title": "Kokkuvõte",
        "games": "Seansse mängitud",
        "place": "Koht",
        "effectiveness": "Tõhusus",
        "time": "Aeg"
      }
    },
    "security": {
      "title": "Turvalisus",
      "change_password_title": "Parooli muutmine",
      "change_password": "Muuda parooli",
      "new_password": "Uus parool",
      "confirm_new_password": "Kinnita uus parool",
      "password_requirements": "Parooli nõuded:",
      "password_requirements_1": "Vähemalt 8 märki – mida rohkem, seda parem",
      "password_requirements_2": "Vähemalt üks väiketäht",
      "password_requirements_3": "Vähemalt üks number, sümbol või tühikumärk"
    },
    "statistics": {
      "title": "Statistika"
    }
  },
  "game": {
    "character_memory": {
      "title": "Mida tegelane mäletab",
      "subtitle": "Varasemate kohtumiste mälu, millega tegelane sellesse sessiooni tuleb",
      "preview_subtitle": "Mälu ei ole veel fikseeritud — tegelane saab selle sessiooni alustamise hetkel",
      "unavailable": "Eelmine kohtumine ei ole tegelasele kättesaadav: ta alustab vestlust seda mäletamata.",
      "agreements": "Kokkulepped",
      "player_commitments": "Mängija lubadused",
      "character_commitments": "Tegelase lubadused",
      "open_issues": "Lahtised küsimused",
      "facts": "Nimetatud faktid",
      "attitude": "Suhtumine mängijasse",
      "evaluation_passed": "Selle kohtumise hindamistulemused on tegelasele edastatud",
      "evaluation_not_ready": "Selle kohtumise hinnang ei ole veel valmis — tegelane saab selle kohe, kui see on arvutatud.",
      "evaluation_hidden": "Hinnangutekstid on organisatsiooni sätetega peidetud.",
      "overall_effectiveness": "Üldine tulemuslikkus",
      "outcome": {
        "deal": "Tehing",
        "partial": "Osaliselt",
        "no_deal": "Tehinguta",
        "unclear": "Tulemus ebaselge"
      }
    },
    "meeting_recap": {
      "title": "Kohtumise kokkuvõte",
      "outcome": "Kohtumise tulemus",
      "agreements": "Kokkulepped",
      "player_commitments": "Mängija lubadused",
      "character_commitments": "Tegelase lubadused",
      "open_issues": "Lahtised küsimused",
      "facts": "Nimetatud faktid",
      "pending": "Kohtumise kokkuvõte on veel koostamisel. Palun proovige veidi hiljem uuesti.",
      "unavailable": "Selle kohtumise kokkuvõtet ei õnnestunud koostada.",
      "none": "Sellel mängul kokkuvõtet ei ole."
    },
    "title": "Sessioon",
    "team": "Meeskond",
    "expert": "Ekspert",
    "points": "punkti",
    "your_result": "Teie tulemus",
    "joined_at": "Liitus:",
    "ended_at": "Lõpetamise kuupäev",
    "min": "min.",
    "duration": "Kestus",
    "from_average": "keskmisest",
    "ai_expert": "AI ekspert",
    "ai_evaluation_in_progress": "AI hindamine on pooleli",
    "delete_ai_request": "Kustuta AI tagasiside",
    "ai_expert_refresh": "Värskenda AI tulemusi",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "AI tulemusi ei saa praegu värskendada: AI hindamine on veel pooleli.",
      "answer_pending": "AI tulemusi ei saa praegu värskendada: AI vastust ei ole veel saabunud.",
      "recognition_pending": "AI tulemusi ei saa praegu värskendada: salvestust alles transkribeeritakse.",
      "recognition_has_no_speech": "Salvestuses ei tuvastatud kõnet, seega AI tulemusi ei saa värskendada.",
      "recognition_has_too_little_speech": "Salvestuses on osalejate vahel peaaegu puudu vestlus, seega AI hindamist ei tehtud.",
      "no_ai_evaluation": "Sellel sessioonil ei ole enam AI hinnangut.",
      "game_evaluation_blocked": "Sessioon ei toimunud või tühistati, seega AI hindamine ei ole saadaval."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Salvestuses ei tuvastatud kõnet, seega AI hindamist ei tehtud.",
      "recognition_has_too_little_speech": "Salvestuses on osalejate vahel peaaegu puudu vestlus, seega AI hindamist ei tehtud.",
      "game_evaluation_blocked": "Sessioon ei toimunud või tühistati, seega AI hindamine ei ole saadaval."
    },
    "ai_expert_refresh_failed": "AI tulemuste värskendamine ebaõnnestus.",
    "speaker_mapping": {
      "title": "Osalejad ja hääled",
      "voice": "Hääl {number}",
      "unknown": "Ei ole tuvastatud",
      "needs_review": "Kontrolli osalejaid",
      "needs_review_hint": "Osalejad võidi valesti tuvastada: veendu, et AI tagasiside jõudis õigete inimesteni.",
      "failed": "Osalejaid ei õnnestunud automaatselt tuvastada.",
      "unavailable": "AI teenusepakkuja ei olnud kättesaadav; osalejad tuvastatakse järgmisel hindamisel.",
      "empty": "Transkriptsioonis pole kõnet, mille põhjal osalejaid tuvastada.",
      "corrected_manually": "Käsitsi parandatud",
      "under_reevaluation": "AI hindamine nende osalejatega on pooleli. Kuni see lõpeb, näitab leht eelmisi tulemusi.",
      "confirm": "Osalejad on õiged",
      "review": "Kontrolli",
      "dialog_hint": "Määra igale häälele osaleja. Pärast salvestamist küsitakse AI tagasisidet uuesti.",
      "save": "Salvesta",
      "cancel": "Tühista",
      "confirmed": "Osalejad kinnitatud",
      "fixed": "Osalejad parandatud, AI tagasisidet küsiti uuesti",
      "action_failed": "Toimingut ei õnnestunud lõpetada"
    },
    "ai_expert_created": "Seansi hindamise protsess on alanud. See võtab mõned minutid. Võid lehelt lahkuda – saadame teavituse, kui hinnang on valmis.",
    "expert_already_requested": "Teine osaleja on juba hinnangu taotlenud",
    "request_expert": "Taotle eksperti",
    "assign_expert": "Määra ekspert",
    "ai_process": "Palun oota, töötlen",
    "analyzing_results": "Analüüsin seansi tulemusi...",
    "complete_expert_request": "Lõpeta hindamine",
    "tabs": {
      "description": {
        "title": "Stsenaariumi Kirjeldus",
        "subtitle": "Seansi teave ja reeglid",
        "situation": "Olukord",
        "your_role": "Sinu roll",
        "player_role": "Mängija roll: {name}",
        "team_tab": "Meeskond {team}",
        "empty": "Sellel seansil pole kirjeldusi.",
        "load_error": "Kirjelduse laadimine ebaõnnestus. Proovi hiljem uuesti."
      },
      "results": {
        "title": "Tulemused",
        "effectiveness_summary": "Meeskonna tõhusus",
        "your_effectiveness": "Teie tõhusus",
        "parameters_section": "Parameetrid",
        "parameter": "Parameeter",
        "target": "Eesmärk",
        "coefficient": "Koefitsient",
        "value": "Kokkulepe",
        "points": "Punktid",
        "points_short": "punkti",
        "combinations": "Kombinatsioonid",
        "combination_bonus": "Kombinatsiooni boonus",
        "questions": "Küsimused",
        "question": "Küsimus",
        "answer": "Vastus",
        "total": "Kokku"
      },
      "comments": {
        "title": "Videoanalüüs",
        "comments": "Kommentaarid",
        "no_comments": "Kommentaare pole veel",
        "no_video": "Video pole saadaval",
        "video_processing": "Videot töödeldakse...",
        "count": "kommentaari",
        "delete": "Kustuta",
        "edit": "Muuda",
        "popup": {
          "add": "Lisa kommentaar",
          "edit": "Muuda kommentaari",
          "comment": "Kommentaar",
          "player": "Osaleja",
          "all": "Kõigile"
        }
      },
      "feedback": {
        "title": "Seansi hindamine",
        "no_feedback": "Hinnanguid veel pole",
        "no_feedback_description": "Sellele sessioonile pole veel tagasisidet lisatud",
        "overall_score": "Üldhinne",
        "skills_evaluated": "{count} oskust hinnatud",
        "no_comment": "Kommentaar puudub",
        "score_button": "Hinda osalejat",
        "player": "Osaleja",
        "author": "Autor",
        "download": "Laadi video alla",
        "download_transcript": "Laadi transkriptsioon alla",
        "evaluators": {
          "ai": "Ekspert",
          "expert": "Ekspert",
          "player": "Osaleja",
          "manager": "Juht",
          "head": "Juht"
        },
        "popup": {
          "score": {
            "title": "Osaleja hindamine",
            "comment": "Kommentaar",
            "error": "Pead hindama kõik osaleja oskused",
            "save_error": "Hinnangut ei õnnestunud salvestada. Võimalik, et sul pole õigust seda osalejat hinnata."
          }
        }
      },
      "checklist": {
        "title": "Kontrollnimekiri",
        "total": "Läbitud punktid",
        "pass": "Läbitud",
        "fail": "Läbimata",
        "cannot_assess": "Ei ole võimalik hinnata",
        "comment": "Üldkommentaar",
        "category": "Kategooria",
        "author": "Hindaja",
        "player": "Osaleja",
        "passed_of": "{passed} {total}-st",
        "evidence": "Tõendid",
        "rationale": "Põhjendus",
        "no_results": "Kontrollnimekirja hindamine pole veel valmis",
        "no_results_description": "Seda sessiooni pole veel kontrollnimekirja alusel hinnatud"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Loo uus",
        "edit_ai_profile": "Muuda",
        "delete_ai_profile": "Kustuta",
        "confirm_delete_ai_profile": "Kas olete kindel, et soovite selle AI profiili kustutada?",
        "first_header": "Põhiseaded",
        "second_header": "AI-osaleja",
        "third_header": "Stsenaariumi kirjeldus",
        "is_public": "Avalik",
        "is_public_hint": "Kui lubatud — stsenaarium on osalejatele valimiseks saadaval.",
        "title": "Info",
        "subtitle": "Stsenaariumi põhiandmed",
        "image": "stsenaariumi pilt",
        "field_title": "Pealkiri",
        "competence": "Kompetents",
        "description": "Kirjeldus",
        "description_a": "Kirjeldus meeskonnale A",
        "description_b": "Kirjeldus meeskonnale B",
        "next_scenario_label": "Järgmine stsenaarium",
        "next_scenario_placeholder": "Pole valitud",
        "next_scenario_hint": "Pärast selle stsenaariumiga seansi lõpetamist luuakse automaatselt sessioon järgmise stsenaariumiga.",
        "memory_header": "Seos järgmise kohtumisega",
        "memory_group_evaluation": "Järgmise kohtumise hinnang",
        "memory_group_character": "Järgmise kohtumise tegelane",
        "memory_pass_to_next": "mäletab seda kohtumist",
        "memory_pass_to_next_hint": "Järgmise stsenaariumi tegelane alustab vestlust nagu tuttavaga: ta saab selle kohtumise lühikokkuvõtte, kokkulepped, mõlema poole lubadused, lahtised küsimused ja nimetatud faktid. Salvestist ega sõnasõnalisi tsitaate talle ei edastata. Lülitage see sisse, kui järgmine kohtumine jätkab seda: teine läbirääkimiste voor, korrapärane üks-ühele kohtumine.",
        "memory_pass_evaluation_to_next": "teab selle kohtumise hinnangut",
        "memory_pass_evaluation_to_next_hint": "Koos mäluga saab tegelane oskuste tagasiside tekstid ja selle kohtumise üldtulemuse ning saab käituda nagu treener, kes mäletab, mis mängijal õnnestus.",
        "memory_evaluate_next_with_agreements": "arvestab selle kohtumise kokkuleppeid",
        "memory_evaluate_next_with_agreements_hint": "Järgmise kohtumise hindamisel näeb tehisintellektist ekspert selle kohtumise kokkuleppeid, mõlema poole lubadusi ja lahtisi küsimusi ning saab kontrollida, kas mängija pidas lubatust kinni. Eelmise kohtumise punkte ega hinnangutekste eksperdile ei edastata, et need uut hinnangut ei kallutaks.",
        "ai_profile": "AI-profiil",
        "ai_profile_placeholder": "Ainult AI-sessioonide jaoks",
        "ai_description": "AI kirjeldus",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Tõhusa AI-viiba kirjutamine nõuab kogemust. Halvasti kirjutatud viip võib põhjustada stsenaariumi ettearvamatut käitumist. Kui te pole kindel, kasutage nuppu «Optimeeri tehisintellektiga», proovige stsenaariumite genereerimist või pöörduge oma juhi poole.",
        "knowledge_base_header": "Teadmusbaas",
        "knowledge_base_documents": "Teadmusbaasi dokumendid",
        "knowledge_base_documents_hint": "Lisa dokumendid AI-mängija konteksti tagamiseks",
        "knowledge_base_no_documents": "Dokumente pole saadaval. Laadige dokumendid üles lehel \"Teadmusbaas\".",
        "knowledge_base_chunks": "{count} tükki",
        "knowledge_base_purpose_voice": "AI-sessioon",
        "knowledge_base_purpose_eval": "Hindamine"
      },
      "settings": {
        "title": "Seaded",
        "subtitle": "Stsenaariumi seadistused",
        "min_players": "Min osalejaid",
        "min_players_hint": "Arv 2 kuni 20",
        "max_players": "Max osalejaid",
        "max_players_hint": "Arv 2 kuni 20",
        "protocol_time": "Protokolli aeg (min)",
        "protocol_time_hint": "Arv 1 kuni 1440",
        "preparation_time": "Ettevalmistusaeg (min)",
        "preparation_time_hint": "Arv 0 kuni 1440. 0 - kirjeldus on kohe nähtav",
        "game_duration": "Seansi kestus (min)",
        "game_duration_hint": "Arv 1 kuni 60",
        "is_team": "Stsenaarium meeskondadele",
        "is_camera_required": "Osalejate kaamerad on kohustuslikud",
        "is_self_rated": "Osalejad saavad end ise hinnata",
        "is_each_other_rated": "Osalejad saavad üksteist hinnata",
        "is_expert_rated": "Eksperdi hinnang võimalik",
        "is_ai_rated": "AI hinnang võimalik",
        "show_results": "Tulemuste kuvamine",
        "automatically": "automaatselt",
        "manually": "käsitsi"
      },
      "parameters": {
        "title": "Parameetrid",
        "subtitle": "Osaleja parameetrid",
        "field_title": "Pealkiri",
        "team_a": "Meeskond A",
        "team_b": "Meeskond B",
        "player_a": "Osaleja A",
        "player_b": "Osaleja B",
        "points": "Punktid",
        "ratio": "Suhe",
        "add": "Lisa parameeter"
      },
      "questions": {
        "title": "Küsimused",
        "subtitle": "Küsimused osalejatele",
        "question": "Küsimus",
        "team": "Meeskond",
        "team_placeholder": "Vali meeskond",
        "answers": "Vastused",
        "points": "Punktid",
        "select_answers": "Vali vastused",
        "add_combination": "Lisa kombinatsioon",
        "add_question": "Lisa küsimus"
      },
      "next": "Järgmine",
      "previous": "Eelmine",
      "save": "Salvesta"
    },
    "saved": "Stsenaarium salvestatud",
    "to_list": "Tagasi loendisse",
    "add_detail": "Lisa stsenaarium",
    "edit_detail": "Muuda stsenaariumi"
  },
  "notifications": {
    "title": "Teavitused",
    "mark_unread": "Märgi kõik lugemata",
    "mark_read": "Märgi kõik loetuks",
    "delete_all": "Kustuta kõik",
    "no_new": "Teavitusi ei leitud",
    "system": "Süsteem",
    "evaluation": {
      "ready": {
        "subject": "Sessioon #:gameNumber – hinnang",
        "text": "Seansi hindas ekspert"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Sulle määrati sessioon",
        "role": "Roll:"
      },
      "proposal": {
        "subject": "Seansi aja kooskõlastamine",
        "time": "Aeg:",
        "description": "Palun kinnita või paku oma variant"
      },
      "agreed": {
        "subject": "Seansi aeg on kokku lepitud",
        "time": "Aeg:",
        "description": "Kirjeldus ja ettevalmistusvalikud avanevad :preparationTime minutit enne algust",
        "description_zero": "Saad nüüd stsenaariumi kirjeldusega tutvuda ja valmistuda"
      },
      "preparation": {
        "subject": "Ettevalmistus seansi jaoks",
        "text": "Seansi ettevalmistus on saadaval."
      },
      "started": {
        "subject": "Sessioon #:gameNumber on alanud",
        "text": "Liitu!"
      },
      "missed": {
        "subject": "Sessioon #:gameNumber jäi ära",
        "text": "Vabandame, jäid sessioonist ilma"
      },
      "completed": {
        "subject": "Sessioon #:gameNumber lõpetatud",
        "text": "Edukas sessioon"
      },
      "failed": {
        "subject": "Sessioon #:gameNumber ebaõnnestus",
        "text": "Lõppes ebaõnnestunult"
      },
      "results": {
        "proposed": {
          "subject": "Seansi protokoll #:gameNumber on kokku lepitud",
          "text": "Kokkulepe on saadaval"
        },
        "declined": {
          "subject": "Seansi protokoll #:gameNumber lükati tagasi",
          "text": "Ettepanek lükati tagasi"
        },
        "not_agreed": {
          "subject": "Seanss #:gameNumber: pooled ei jõudnud kokkuleppele",
          "text": "Vastase kapten märkis, et pooled ei jõudnud kokkuleppele. Seanss lõppes ebaõnnestunult ja tulemusi ei arvestatud."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Sessioonikohtumine #:gameNumber on lõppenud",
          "text": "Palun oota tulemusi."
        },
        "ended-captain": {
          "subject": "Sessioonikohtumine #:gameNumber on lõppenud",
          "text_fill": "Palun täida protokoll.",
          "text_wait": "Palun oota, kuni protokoll täidetakse.",
          "protocol_time": "Protokolli aeg (minutites): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "Lubatud JPG, GIF või PNG. Maksimaalne suurus 2MB",
    "avatar_label_choose": "Vali",
    "avatar_label_your_avatar": "sinu avatar",
    "name": "Eesnimi",
    "last_name": "Perekonnanimi",
    "patronymic": "Isanimi",
    "phone": "Telefon",
    "timezone": "Ajavöönd",
    "language": "Keel",
    "country": "Riik",
    "invalid_phone": "Vale telefoninumber",
    "save_changes": "Salvesta muudatused",
    "account": "Konto",
    "security": "Turvalisus",
    "statistics": "Statistika",
    "notifications": "Teavitused",
    "change_password_title": "Parooli muutmine",
    "change_password": "Muuda parooli",
    "current_password": "Praegune parool",
    "new_password": "Uus parool",
    "confirm_new_password": "Kinnita uus parool",
    "password_requirements": "Parooli nõuded:",
    "password_requirements_1": "Vähemalt 8 märki – mida rohkem, seda parem",
    "password_requirements_2": "Vähemalt üks väiketäht",
    "password_requirements_3": "Vähemalt üks number, sümbol või tühikumärk",
    "two_factor_title": "Kahefaktoriline autentimine",
    "two_factor_description": "Lisa oma kontole täiendav turvakiht",
    "two_factor_org_enforced": "Kahefaktoriline autentimine on sinu organisatsioonis kohustuslik",
    "two_factor_method": "Autentimise meetod",
    "two_factor_disabled": "Keelatud",
    "two_factor_email": "E-post",
    "two_factor_sms": "SMS",
    "two_factor_save": "Salvesta 2FA seaded"
  },
  "auth": {
    "password": "Parool",
    "new_password": "Uus parool",
    "remember": "Mäleta mind",
    "timezone": "Ajavöönd",
    "forgot": "Unustasid parooli",
    "login": "Logi sisse",
    "login_title": "Sisselogimine",
    "new_password_title": "Parooli muutmine",
    "change_password": "Salvesta",
    "country": "Riik",
    "invalid_phone": "Vale telefoninumber",
    "privacy_policy_title": "Privaatsuspoliitika",
    "privacy_policy_text": "Privaatsuspoliitika tekst...",
    "first_time": "Oled platvormil uus?",
    "registration": "Loo konto",
    "forgot_title": "Unustasid parooli?",
    "forgot_description": "Sisesta oma e-post ja me saadame juhised parooli lähtestamiseks",
    "send_reset_link": "Saada lähtestamise link",
    "back_to_login": "Tagasi sisselogimisele",
    "register": "Registreeru",
    "name": "Eesnimi",
    "last_name": "Perekonnanimi",
    "patronymic": "Isanimi",
    "phone": "Telefon",
    "enter_password": "Sisesta parool",
    "confirm_password": "Kinnita parool",
    "not_first_time": "Juba konto olemas?",
    "agree_too": "Nõustun",
    "privacy_policy": "privaatsuspoliitika ja tingimustega",
    "accept": " Nõustun ",
    "password_validation": "Väli peab sisaldama vähemalt üht suurt ja väikest tähte, erimärki ning numbrit (min 8 märki)",
    "password_confirm_error": "Parooli kinnitamine ei ühti",
    "set_password": "Sea uus parool",
    "reset_password": "Lähtesta parool",
    "for": "jaoks",
    "sign_in_to_for": "Logi sisse rakendusse {app} ({org} jaoks)",
    "registration_title": "Registreerimine",
    "verify_title": "E-posti kinnitus",
    "verify_head": "Kinnita oma e-post",
    "verify_description": "Konto aktiveerimise link saadeti sinu e-posti aadressile. Palun järgi kirjaga kaasas olevat linki.",
    "verify_new_link": "Uus kinnituse link on saadetud registreerimisel antud e-postile.",
    "verify_send": "Saada kinnituskiri uuesti",
    "verify_spam": "Tegid liiga palju päringuid, proovi minuti pärast uuesti",
    "verify_logout": "Logi välja",
    "two_factor_title": "Kahefaktoriline autentimine",
    "two_factor_description_email": "Saatsime kinnituskoodi sinu e-posti aadressile. Palun sisesta kood allpool.",
    "two_factor_description_sms": "Saatsime kinnituskoodi sinu telefoninumbrile. Palun sisesta kood allpool.",
    "two_factor_code_label": "Kinnituskood",
    "two_factor_code_placeholder": "Sisesta 6-kohaline kood",
    "two_factor_verify": "Kinnita",
    "two_factor_resend": "Saada kood uuesti",
    "two_factor_resend_success": "Uus kood on saadetud",
    "two_factor_back": "Tagasi sisselogimisele"
  },
  "filepond": {
    "upload": "Laadi üles",
    "upload_complete": "Üleslaadimine lõpetatud",
    "uploading": "Üleslaadimine",
    "loading": "Laadimine",
    "tap_to_cancel": "tühista puudutusega",
    "tap_to_undo": "võta tagasi puudutusega",
    "upload_aborted": "Üleslaadimine tühistati",
    "file_too_large": "Fail on liiga suur"
  },
  "text-editor": {
    "image": "Lohista ja aseta pilt toimetisse"
  },
  "webrtc": {
    "ready_to_start": "Valmis alustama",
    "connected": "Ühendatud - räägi nüüd!",
    "connection_lost": "Ühendus katkes. Palun proovi uuesti."
  },
  "device_settings": {
    "title": "Audio- ja videoseadmete seaded",
    "speaker": "Kõlar/Heliväljund",
    "refresh_devices": "Värskenda seadmeid",
    "speaker_switch_unsupported": "Kõlari vahetamine ei ole selles brauseris toetatud"
  },
  "device_setup": {
    "mic_level": "Mikrofoni tase",
    "mic_on": "Sees",
    "mic_off": "Väljas",
    "cam_on": "Sees",
    "cam_off": "Väljas"
  },
  "device_test": {
    "title": "Testi heliseadmeid",
    "speaker_test": "Kõlari test",
    "speaker_hint": "Klõpsa nuppu, et esitada testhelis valitud kõlari kaudu",
    "play_sound": "Esita testheli",
    "playing": "Esitamine...",
    "speaker_success": "Heli esitatud ✓",
    "mic_test": "Mikrofoni test",
    "mic_hint": "Klõpsa nuppu ja räägi mikrofoni, et kontrollida, kas see töötab",
    "volume_level": "Helitugevus",
    "speak_now": "Räägi nüüd...",
    "seconds_short": "s",
    "start_mic_test": "Testi mikrofoni",
    "testing": "Testimine...",
    "test_again": "Testi uuesti",
    "mic_success": "Mikrofon töötab korrektselt!",
    "mic_fail": "Mikrofoni probleem tuvastatud",
    "mic_fail_hint": "Heli ei tuvastatud. Kontrolli, kas mikrofon on ühendatud, pole vaigistatud ja on seadetes õigesti valitud."
  },
  "ai_assistant_types": {
    "type": "Tüüp",
    "negotiation": "Läbirääkimised",
    "feedback": "Tagasiside",
    "ai_profile": "AI sessioon"
  },
  "Login": "Login",
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Welcome": "Welcome",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Close Alert": "Close Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Otp Input": "Otp Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "Edit",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "Add",
  "User": "User",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Register",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "Permissions",
  "Apps": "Apps",
  "Misc": "Misc",
  "Wizard Pages": "Wizard Pages",
  "Form Wizard": "Form Wizard",
  "Numbered": "Numbered",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editors",
  "Front Pages": "Front Pages",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Payment",
  "Swiper": "Swiper",
  "Product": "Product",
  "Category": "Category",
  "Order": "Order",
  "Details": "Details",
  "Customer": "Customer",
  "Manage Review": "Manage Review",
  "Referrals": "Referrals",
  "Settings": "Settings",
  "Overview": "Overview",
  "My Course": "My Course",
  "Course Details": "Course Details",
  "Academy": "Academy",
  "Logistics": "Logistics",
  "Dashboard": "Dashboard",
  "Fleet": "Fleet",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Hooldus",
  "maintenance-page": {
    "title": "Hoolduse seaded",
    "notification_section": "Üldine teavitus",
    "notification_placeholder": "Sisestage teavitussõnum kõigile kasutajatele",
    "notification_hint": "See sõnum kuvatakse kõigile autenditud kasutajatele hoiatusena",
    "games_section": "Sessioonide blokeerimine",
    "games_blocked_label": "Blokeeri uued sessioonid",
    "games_blocked_hint": "Kui see on lubatud, ei saa kasutajad uusi seansse luua ega alustada. Olemasolevatele sessioonidele saab siiski liituda.",
    "save": "Salvesta",
    "clear": "Tühjenda",
    "clear_confirm": "Kas olete kindel, et soovite teavituse tühjendada?",
    "last_updated": "Viimati uuendatud",
    "updated_by": "uuendaja",
    "games_blocked_message": "Vabandame ebamugavuste pärast. Platvorm on hetkel hooldustööde all. Sessioonid on ajutiselt kättesaamatud."
  },
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "No data available",
    "close": "Close",
    "open": "open",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimiter"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Items per page:",
      "itemsPerPageAll": "All",
      "pageText": "{0}-{1} of {2}",
      "firstPage": "First Page",
      "prevPage": "Previous Page",
      "nextPage": "Next Page",
      "lastPage": "Last Page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "first": "first",
        "last": "last",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Oskuste arengu aruanne",
    "generate": "Genereeri",
    "generate_description": "Genereeri põhjalik oskuste arengu aruanne valitud perioodi kohta",
    "manager_description": "Genereeri oskuste arengu aruandeid oma organisatsiooni töötajatele",
    "date": "Kuupäev",
    "competence": "Kompetents",
    "period": "Periood",
    "status_label": "Olek",
    "actions": "Tegevused",
    "employee": "Töötaja",
    "view": "Vaata aruannet",
    "download_pdf": "Laadi PDF alla",
    "no_reports": "Ühtegi aruannet pole veel genereeritud",
    "data_not_available": "Aruande andmed pole veel saadaval",
    "generation_failed": "Aruande genereerimine ebaõnnestus",
    "retry": "Proovi uuesti",
    "rate_limit_exceeded": "Aruande genereerimise limiit on täis. Palun proovige hiljem uuesti.",
    "too_many_pending": "Teil on liiga palju pooleliolevaid aruandeid. Palun oodake, kuni need valmivad.",
    "no_games_for_report": "Valitud perioodi ja kompetentsi jaoks ei leitud lõpetatud seansse. Aruannet ei saa genereerida.",
    "report_already_exists": "Selliste parameetritega aruanne on juba olemas. Vaadake allolevat nimekirja.",
    "period_too_long": "Aruande periood ei tohi ületada ühte aastat.",
    "invalid_parameters": "Kontrollige kompetentsi ja perioodi",
    "filter_by_employee": "Filtreeri töötaja järgi...",
    "batch": {
      "mode_single": "Üks aruanne",
      "mode_batch": "Partii",
      "load_employees": "Näita töötajaid",
      "sessions": "Sessioone",
      "no_candidates": "Valitud kompetentsi ja perioodi kohta pole ühtegi lõpetatud sessiooniga töötajat",
      "generate_selected": "Koosta ({count})",
      "selected_limit": "Korraga saab valida kuni {max} töötajat",
      "progress": "Valmis {ready} / {total}",
      "failed_count": "Vigu: {count}",
      "status_unknown": "Olek teadmata",
      "status_unknown_hint": "Aruannet nimekirjast ei leitud — vaadake allolevat aruannete tabelit",
      "reused": "Taaskasutatud aruandeid: {count} — koostatud viimase {hours} tunni jooksul ja neid ei loodud uuesti",
      "reused_badge": "Taaskasutatud",
      "reused_on": "Koostatud {date}",
      "download_all": "Laadi kõik alla",
      "toggle_details": "Näita partii koosseisu",
      "dismiss_confirm": "Partii on veel koostamisel. Kas eemaldada see ekraanilt? Edenemine ja nupp „Laadi kõik alla“ lähevad kaotsi, aruanded jäävad allolevasse nimekirja.",
      "archive_unavailable": "Arhiivi ei õnnestunud koostada: osa aruandeid pole veel valmis või pole enam saadaval",
      "archive_failed": "Arhiivi ei õnnestunud alla laadida",
      "archive_building": "Arhiivi koostamine…",
      "archive_build_failed": "Arhiivi ei õnnestunud koostada. Proovige uuesti.",
      "candidates_failed": "Töötajate nimekirja ei õnnestunud laadida",
      "stale_selection": "Osa valitud töötajaid pole enam saadaval. Nimekiri on värskendatud — valige uuesti."
    },
    "quota": {
      "remaining_hour": "Aruannete limiit: {limit} tunnis. Praegu saab tellida veel {remaining}. Valige vähem töötajaid või proovige uuesti kell {time}.",
      "remaining_day": "Aruannete limiit: {limit} päevas. Praegu saab tellida veel {remaining}. Valige vähem töötajaid või proovige uuesti kell {time}.",
      "exhausted_hour": "Aruannete limiit ({limit} tunnis) on täis. See uueneb kell {time}.",
      "exhausted_day": "Aruannete limiit ({limit} päevas) on täis. See uueneb kell {time}.",
      "too_large_hour": "Aruannete limiit: {limit} tunnis. Valige vähem töötajaid.",
      "too_large_day": "Aruannete limiit: {limit} päevas. Valige vähem töötajaid."
    },
    "status": {
      "pending": "Ootel",
      "collecting_data": "Andmete kogumine...",
      "analyzing": "Tehisintellekti analüüs...",
      "generating_pdf": "PDF genereerimine...",
      "ready": "Valmis",
      "failed": "Ebaõnnestunud"
    },
    "report": {
      "kicker": "Kompetentsi arengu aruanne",
      "position": "Ametikoht",
      "department": "Osakond",
      "period": "Periood",
      "games_count": "Läbiviidud sessioonid",
      "not_specified_f": "Määramata",
      "not_specified_n": "Määramata",
      "fig": {
        "your_average": "Teie keskmine tulemus",
        "company_average": "Ettevõtte keskmine",
        "participants": "Osalejaid perioodil",
        "skills_count": "Hinnatud oskusi"
      },
      "sec": {
        "profile": "Kompetentsi profiil",
        "trend": "Kulg sessioonide lõikes",
        "strengths": "Millele toetuda",
        "priorities": "Kolm arenguprioriteeti",
        "skills": "Analüüs oskuste kaupa",
        "plan": "Kolme kuu plaan"
      },
      "legend": {
        "you": "Teie tulemus",
        "company": "Ettevõtte keskmine"
      },
      "dotplot_caption": "Kõrvalekalle keskmisest — suurimast edumaast suurima mahajäämuseni",
      "trend_disclaimer": "Üksikute sessioonide tulemused ei ole otseselt võrreldavad: juhtumite keerukus erineb sessiooniti. Madalam tulemus ei tähenda iseenesest oskuse langust — see graafik on tähelepanek, mitte hinnang.",
      "no_comparison": "Võrdlus ettevõtte keskmisega ei ole võimalik: sellel perioodil läbis selle kompetentsi sessioone vähem kui kolm inimest. Aruanne tugineb absoluutsetele tulemustele.",
      "skill": {
        "works": "Mis õnnestub",
        "blocks": "Mis takistab",
        "actions": "Mida teha",
        "out_of_ten": "10 punktist",
        "company_short": "ettevõte"
      },
      "level": {
        "outstanding": "Silmapaistev tulemus",
        "strength": "Tugevus",
        "meets_standard": "Ettevõtte tasemel",
        "needs_attention": "Vajab tähelepanu",
        "needs_development": "Arenguvaldkond"
      },
      "plan": {
        "month": "Kuu",
        "goals": "Eesmärgid",
        "actions": "Tegevused"
      },
      "colophon": {
        "built_on": "Aruanne põhineb perioodi {from} — {to} sessioonidel. Sessioone kokku: {count}.",
        "comparison": "Võrdlus on tehtud sama perioodi ettevõtte keskmisega. Osalejaid: {count}."
      }
    }
  },
  "api-tokens": "API-tokenid",
  "api-tokens-page": {
      "select_user": "Kasutaja",
      "select_user_hint": "Valige kasutaja, et vaadata ja hallata tema API-tokeneid.",
      "no_users_found": "Kasutajaid ei leitud",
      "no_tokens": "Sellel kasutajal ei ole API-tokeneid.",
      "token_name": "Nimi",
      "abilities": "Õigused",
      "ability": "Õigus",
      "created_at": "Loodud",
      "last_used_at": "Viimati kasutatud",
      "expires_at": "Aegub",
      "actions": " ",
      "issue_token": "Väljasta token",
      "issue": "Väljasta",
      "issue_failed": "Tokeni väljastamine ebaõnnestus",
      "token": "Token",
      "plaintext_warning": "Kopeerige see token kohe — seda ei kuvata uuesti.",
      "revoke": "Tühista",
      "revoke_confirm": "Kas olete kindel, et soovite selle tokeni tühistada? Integratsioonid, mis seda kasutavad, lõpetavad töötamise."
  },
  "subscription": {
    "current_plan": "Praegune plaan",
    "expires_at": "Aegub: {date}",
    "no_active_plan": "Aktiivne tellimisplaan puudub",
    "quota_warning": "Kvoot on peaaegu täis",
    "regular_games": "Tavalised sessioonid",
    "ai_games": "AI sessioonid",
    "any_games": "Kõik sessioonid",
    "used_of": "{used} / {limit}",
    "remaining": "Järel: {count}",
    "quota_exceeded": "Kvoot on ületatud",
    "tickets_only": "Krediidipaketid",
    "session_package": "Sessioonipakett",
    "games_available": "Sessioonid",
    "users": "Kasutajad",
    "active_users": "Aktiivsed kasutajad",
    "active_tickets": "Krediidipaketid",
    "ticket_charges": "{charges} kreditit",
    "ticket_no_expiry": "Tähtajatu",
    "unlimited": "Piiramatu",
    "no_game_limits": "Piiranguid sessioonide arvule ei ole"
  },
  "knowledge-base-page": {
    "provider-unsupported": "Teadmusbaas ei ole teie organisatsiooni praeguse AI pakkujaga saadaval."
  },
  "candidate-page": {
    "document_title": "Intervjuu",
    "greeting": "Tere, {name}!",
    "intro_lead": "{organization} kutsub Teid intervjuule virtuaalse vestluspartneriga vakantsi «{vacancy}» jaoks.",
    "duration": "Intervjuu kestab umbes {minutes} min.",
    "requirements_title": "Mida on vaja",
    "requirement_mic": "Töötav mikrofon, eelistatavalt peakomplekt",
    "requirement_camera_required": "Sisselülitatud kaamera: selle intervjuu jaoks on see kohustuslik",
    "requirement_camera_optional": "Kaamera ei ole kohustuslik, kuid sellega on vestlus loomulikum",
    "requirement_browser": "Arvuti värske Chrome, Edge või Safari brauseriga",
    "requirement_network": "Stabiilne internetiühendus ja vaikne koht, kus Teid ei segata",
    "continue": "Jätkake",
    "consent": {
      "accept": "Olen tekstiga tutvunud ja annan nõusoleku oma isikuandmete töötlemiseks",
      "back": "Tagasi",
      "start": "Alustage intervjuud"
    },
    "terminal": {
      "finished": {
        "title": "Täname!",
        "text": "Intervjuu on lõppenud ja tulemus on saadetud värbajale — tema võtab Teiega ühendust. Selle lehe võite sulgeda."
      },
      "already_completed": {
        "title": "Intervjuu on juba läbitud",
        "text": "Selle lingiga on intervjuu juba lõpetatud. Kui peate selle uuesti läbima, võtke ühendust värbajaga."
      },
      "not_found": {
        "title": "Linki ei leitud",
        "text": "Aadressis võib olla viga või link ei kehti enam. Kontrollige värbaja saadetud kirja või võtke temaga ühendust."
      },
      "session_conflict": {
        "title": "Olete sisse logitud teise kontoga",
        "text": "Logige praegusest kontost välja või avage link privaatses brauseriaknas."
      },
      "link_revoked": {
        "title": "Juurdepääs lingile on suletud",
        "text": "Värbaja tühistas selle lingi. Uue saamiseks võtke temaga ühendust."
      },
      "link_expired": {
        "title": "Lingi kehtivusaeg on lõppenud",
        "text": "Uue lingi saamiseks võtke ühendust värbajaga."
      },
      "attempts_exhausted": {
        "title": "Katsed on otsas",
        "text": "Kõik selle lingi katsed on ära kasutatud. Võtke ühendust värbajaga."
      },
      "unavailable": {
        "title": "Praegu ei saa alustada",
        "text": "Proovige hiljem uuesti või võtke ühendust värbajaga."
      },
      "rate_limited": {
        "title": "Liiga palju katseid",
        "text": "Oodake minut ja värskendage lehte."
      },
      "aborted": {
        "title": "Intervjuu ei alanud",
        "text": "Värskendage lehte ja proovige uuesti. Kui see ei aita, võtke ühendust värbajaga."
      },
      "generic": {
        "title": "Midagi läks valesti",
        "text": "Värskendage lehte ja proovige uuesti. Kui see ei aita, võtke ühendust värbajaga."
      }
    }
  },
  "recruiting-page": {
    "title": "Värbamine",
    "create": "Uus vakants",
    "edit": "Muuda vakantsi",
    "empty": "Vakantse pole veel",
    "load_error": "Vakantside nimekirja ei õnnestunud laadida",
    "retry": "Proovi uuesti",
    "back": "Tagasi vakantside juurde",
    "open": "Kandidaadid",
    "archive": "Arhiveeri",
    "no_expiry": "Tähtajatu",
    "confirm_archive": "Viia see vakants arhiivi? Pärast seda ei saa selle jaoks enam linke väljastada.",
    "headers": {
      "title": "Vakants",
      "scenario": "Stsenaarium",
      "status": "Staatus",
      "expires_at": "Kehtib kuni",
      "actions": "Toimingud"
    },
    "status": {
      "draft": "Mustand",
      "active": "Aktiivne",
      "archived": "Arhiveeritud"
    },
    "dialog": {
      "title_label": "Vakantsi pealkiri",
      "scenario_label": "Intervjuu stsenaarium",
      "scenario_placeholder": "Vali stsenaarium AI-intervjuu jaoks",
      "scenario_hint": "Loetletud on ainult stsenaariumid, mis sobivad sessiooniks vs AI",
      "status_label": "Staatus",
      "expires_label": "Kehtib kuni",
      "expires_hint": "Tühi = tähtajatu",
      "save": "Salvesta",
      "cancel": "Tühista"
    },
    "messages": {
      "created": "Vakants loodud",
      "updated": "Vakants uuendatud",
      "archived": "Vakants arhiveeritud",
      "revoked": "Link tühistatud",
      "attempt_granted": "Kandidaadile anti veel üks katse",
      "copied": "Link kopeeritud",
      "error": "Midagi läks valesti"
    },
    "candidates": {
      "title": "Kandidaadid",
      "empty": "Selle vakantsi jaoks pole veel ühtegi linki väljastatud",
      "load_error": "Kandidaatide nimekirja ei õnnestunud laadida",
      "issue": "Väljasta link",
      "import": "Impordi failist",
      "expired": "Aegunud",
      "no_games": "Intervjuu pole alanud",
      "attempts": "{used} / {allowed}",
      "revoke": "Tühista link",
      "extra_attempt": "Anna veel üks katse",
      "open_result": "Ava intervjuu tulemus",
      "confirm_revoke": "Tühistada kandidaadi link? Juurdepääs kaob kohe, sealhulgas pooleliolevale intervjuule.",
      "confirm_extra_attempt": "Anda kandidaadile veel üks katse?",
      "headers": {
        "candidate": "Kandidaat",
        "link_status": "Link",
        "invite": "Kutse",
        "game_status": "Intervjuu",
        "attempts": "Katsed",
        "expires_at": "Link kehtib kuni",
        "actions": "Toimingud"
      },
      "link_status": {
        "created": "Väljastatud",
        "opened": "Avatud",
        "in_progress": "Intervjuu käib",
        "completed": "Intervjuu lõpetatud",
        "revoked": "Tühistatud"
      },
      "invite_status": {
        "not_sent": "Saatmata",
        "queued": "Järjekorras",
        "sent": "Saadetud",
        "failed": "Saatmine ebaõnnestus"
      },
      "invite_sent_at": "E-posti teenus võttis kirja vastu: {date}",
      "invite_failure": {
        "rejected": "E-posti teenus lükkas kirja tagasi — saada link kandidaadile ise",
        "transport": "Saatmine ebaõnnestus — saada link kandidaadile ise",
        "revoked": "Link on tühistatud",
        "sending_disabled": "E-kirjade saatmine on välja lülitatud",
        "blocked": "Aadress on stopp-nimekirjas — saada link kandidaadile ise"
      }
    },
    "issue_dialog": {
      "title": "Väljasta isiklik link",
      "name": "Eesnimi",
      "last_name": "Perekonnanimi",
      "email": "E-post",
      "phone": "Telefon",
      "attempts": "Lubatud katsete arv",
      "expires_at": "Link kehtib kuni",
      "expires_hint": "Tühi väli = link kehtib sama kaua kui vakants",
      "submit": "Väljasta link",
      "close": "Sulge",
      "result_title": "Link väljastatud",
      "warning": "Kopeeri link kohe — seda näidatakse ainult üks kord. Andmebaasis säilib ainult selle räsi, mistõttu linki ei saa taastada: kadunud lingi tuleb tühistada ja uuesti väljastada.",
      "copy": "Kopeeri",
      "copied": "Kopeeritud",
      "send_invite": "Saada kutse aadressile {email}",
      "send_invite_no_email": "Saada kutse e-postiga",
      "send_invite_blocked": "See aadress on stopp-nimekirjas — kirja ei saadeta",
      "invite_queued": "Kutse on järjekorda pandud aadressile {email}",
      "invite_blocked": "Kutset ei saadetud: {email} on stopp-nimekirjas. Saada link kandidaadile ise"
    },
    "import_dialog": {
      "title": "Kandidaatide import",
      "subtitle": "Iga faili rida vastab ühele kandidaadile ja ühele isiklikule lingile.",
      "file": "Kandidaatide nimekirja fail",
      "columns": "Veerud: Eesnimi, Perekonnanimi, E-post, Telefon",
      "limits": "xlsx või semikooloniga CSV, kuni 200 rida ja 10 MB",
      "size_error": "Fail on suurem kui 10 MB",
      "download_example": "Laadi näidis alla",
      "note_title": "Lingid on näha ainult allalaaditud failis",
      "note_text": "Fail laaditakse alla kohe pärast importi. Andmebaasis säilivad ainult linkide räsid, teist korda linke eksportida ei saa — hoia fail alles.",
      "submit": "Impordi",
      "cancel": "Tühista",
      "result_title": "Lingid väljastatud",
      "result": "Väljastatud linke: {count}. Fail on alla laaditud.",
      "invites_blocked": "Saatmata kutseid: {count}. Need aadressid on stopp-nimekirjas — saada lingid neile kandidaatidele ise.",
      "saved_title": "Hoia allalaaditud fail alles",
      "saved_text": "See on ainus koopia neist linkidest: andmebaasis säilivad ainult nende räsid. Kadunud lingi saab ainult tühistada ja uuesti väljastada.",
      "download_again": "Laadi fail uuesti alla",
      "errors_title": "Tagasi lükatud read",
      "error_row": "Rida {row}: {error}",
      "errors_truncated": "…ja veel {count} tagasi lükatud rida. Eespool on kuvatud esimesed 50.",
      "send_invites": "Saada kandidaatidele e-posti kutsed",
      "send_invites_hint": "Kandidaadid, kellel pole e-posti aadressi, kirja ei saa"
    }
  },
  "ai-reports": "AI aruanded",
  "ai-reports-page": {
    "title": "AI aruanded",
    "subtitle": "Kirjeldage aruannet oma sõnadega – koostame kirjelduse, näitame eelvaadet ja ekspordime Excelisse.",
    "status": {
      "draft": "Mustand",
      "pending": "Koostamisel",
      "ready": "Valmis",
      "failed": "Ebaõnnestus"
    },
    "list": {
      "title": "Minu aruanded",
      "new": "Uus aruanne",
      "empty": "Aruandeid pole veel. Klõpsake „Uus aruanne“ ja kirjeldage, mida soovite näha.",
      "untitled": "Nimetu",
      "delete": "Kustuta aruanne",
      "delete_confirm": "Kustutada aruanne koos koostatud failiga?",
      "deleted": "Aruanne kustutatud"
    },
    "dialog": {
      "title": "Dialoog",
      "open_dictionary": "Andmete sõnastik",
      "placeholder": "Näiteks: mitu mängu iga osakond eelmisel kvartalil läbi viis",
      "send": "Saada",
      "empty_title": "Mida aruanne peaks näitama?",
      "empty_text": "Kirjutage tavaliste sõnadega: millised andmed, millise perioodi kohta ja millise jaotuse alusel. Kui midagi jääb puudu, küsin täpsustust.",
      "examples_title": "Näiteks:",
      "examples": {
        "e1": "Mitu mängu iga osakond eelmisel kvartalil läbi viis",
        "e2": "Müügiosakonna keskmine oskuste hinne 2026. aastal",
        "e3": "Töötajad, kes pole rohkem kui kuu aega mänginud",
        "e4": "Kandidaadid vakantsi ja lingi staatuse kaupa viimase 30 päeva jooksul"
      },
      "thinking": "Aruande koostamine…",
      "waiting_hint": "Vastus ilmub siia iseenesest — lehte pole vaja värskendada.",
      "retry": "Proovi uuesti",
      "dismiss": "Peida",
      "spec_ready": "Aruanne on koostatud – kontrollige allolevat eelvaadet ja koostage fail.",
      "stuck_title": "Tundub, et käime ringiratast",
      "stuck_text": "Vaadake andmete sõnastikku ja sõnastage päring selle sõnadega ümber – see on kiirem kui vastata veel ühele täpsustavale küsimusele.",
      "rejected_title": "Seda aruannet ei saa veel koostada",
      "reason": {
        "no_such_measure": "Sellist mõõdikut meie andmetes ei ole. Vaadake mõõdikute loendit sõnastikust.",
        "no_such_field": "Sellist välja meie andmetes ei ole. Vaadake väljade loendit sõnastikust.",
        "cross_dataset": "Päring vajab andmeid korraga kahest andmestikust. Jagage see kaheks aruandeks.",
        "window_function": "Osakaale kogusummast, pingerea kohti ja võrdlust eelmise perioodiga veel ei toetata.",
        "other": "Päring ületab saadaolevad andmed. Vaadake sõnastikku ja proovige teistsugust sõnastust."
      },
      "usage": {
        "employees": "ei ole ühtegi töötajat | {n} töötaja | {n} töötajat",
        "games": "ei ole ühtegi mängu | {n} mäng | {n} mängu",
        "scenarios": "ei ole ühtegi stsenaariumit | {n} stsenaarium | {n} stsenaariumit",
        "evaluations": "ei ole ühtegi hinnangut | {n} hinnang | {n} hinnangut",
        "candidates": "ei ole ühtegi kandidaati | {n} kandidaat | {n} kandidaati"
      },
      "option_created_at": "lisatud {date}"
    },
    "preview": {
      "title": "Eelvaade",
      "no_report": "Valige vasakult aruanne või alustage uut.",
      "no_spec": "Kirjeldage aruannet dialoogis – eelvaade ilmub niipea, kui päring on mõistetud.",
      "spec_title": "Mida aruanne sisaldab",
      "rows_hint": "Kuvatakse esimesed {count} rida",
      "total": "Ridu kokku: {count}",
      "zero_rows": "See päring ei tagasta ühtegi rida. Laiendage perioodi või eemaldage filtrid – tühja faili koostamisel pole mõtet.",
      "zero_rows_hint": "Kontrollige filtrite väärtusi – nende kohta ei pruugi olla andmeid",
      "duplicate_rows": "Mõned eelvaate read on identsed: valitud veerud ei erista selle andmestiku kirjeid. Kontrollige, mida üks rida siin tegelikult tähendab — võib puududa eristav veerg.",
      "too_many_rows": "Aruandes on {count} rida, maksimum on {max}. Kitsendage perioodi või lisage filtreid: piirmäära ületamisel faili ei koostata, mitte ei kärbita.",
      "generate": "Koosta fail",
      "regenerate": "Koosta uuesti",
      "queued": "Fail on koostamisel – kaart uueneb ise, kui see on valmis.",
      "failed": "Aruande koostamine ebaõnnestus",
      "download": "Laadi .xlsx alla",
      "downloads": "Allalaadimisi: {count}",
      "ttl_warning": "Fail säilib {days} päeva ja kustutatakse seejärel – laadige see kohe alla.",
      "expires_at": "Saadaval kuni {date}",
      "expired": "Fail kustutati säilitustähtaja lõppedes – koostage aruanne uuesti."
    },
    "spec": {
      "dataset": "Andmed",
      "columns": "Veerud",
      "measures": "Mõõdikud",
      "group_by": "Jaotus",
      "period": "Periood",
      "period_value": "{field}: {from} kuni {to}",
      "period_all": "Kogu saadaolev periood",
      "filters": "Filtrid",
      "having": "Mõõdikute tingimused",
      "sort": "Sortimine",
      "limit": "Ridade piirang",
      "limit_value": "esimesed {count} rida",
      "granularity": {
        "year": "aasta kaupa",
        "quarter": "kvartali kaupa",
        "month": "kuu kaupa",
        "week": "nädala kaupa",
        "day": "päeva kaupa",
        "dow": "nädalapäeva kaupa"
      },
      "dir": {
        "asc": "kasvavalt",
        "desc": "kahanevalt"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — mitte {value}",
        "in": "{field} — üks järgmistest: {value}",
        "not_in": "{field} — välja arvatud: {value}",
        "gt": "{field} suurem kui {value}",
        "gte": "{field} vähemalt {value}",
        "lt": "{field} väiksem kui {value}",
        "lte": "{field} kõige rohkem {value}",
        "contains": "{field} sisaldab „{value}“",
        "between": "{field} — {from} kuni {to}",
        "is_null": "{field} on täitmata",
        "is_not_null": "{field} on täidetud"
      }
    },
    "value": {
      "yes": "Jah",
      "no": "Ei"
    },
    "dictionary": {
      "title": "Andmete sõnastik",
      "subtitle": "Kõik, mida saab aruandesse kaasata. Loend on reaalajas: see on sama, mille põhjal kirjeldus koostatakse.",
      "fields": "Väljad",
      "measures": "Mõõdikud",
      "values": "Väärtused",
      "show_values": "Näita oma organisatsiooni väärtusi",
      "hide_values": "Peida väärtused",
      "values_error": "Väärtuste laadimine ebaõnnestus – proovige uuesti.",
      "values_empty": "Teie organisatsioonil pole veel väärtusi selle välja jaoks.",
      "limits": {
        "title": "Mida aruanne ei suuda teha",
        "pivot": "Risttabelit veeruga iga osaleja või iga küsimuse kohta ei koostata. Tellige selle asemel pikk vorm: rida iga osaleja-küsimuse paari kohta.",
        "window": "Aruanne ei arvuta kuu-kuult muutust, osakaalu kogusummast, kohta pingereas ega „kolme parimat igas osakonnas“. Võtke jaotus kuude kaupa ja arvutage ülejäänu Excelis.",
        "missing": "Mida süsteem ei salvesta, seda aruandes ei ole: palgad, NPS ja muud mujal hoitavad andmed ei ilmu mitte mingi nime all."
      },
      "empty": "Sõnastik on tühi – pöörduge administraatori poole.",
      "close": "Sulge"
    },
    "errors": {
      "generic": "Midagi läks valesti. Proovige uuesti.",
      "detail": "Ei saadud aru: {value}",
      "rate_limit": "Liiga palju päringuid. Oodake minut ja proovige uuesti.",
      "download": "Faili allalaadimine ebaõnnestus.",
      "turn_failed": "Vastust ei õnnestunud saada. Saatke päring uuesti.",
      "turn_stuck_in_queue": "Päring ei jõudnudki töötlusse — see ootas järjekorras liiga kaua. Saatke see uuesti.",
      "unknown_resolution": "See valik on aegunud — aruanne on vahepeal muutunud. Avage see uuesti ja täpsustage päringut."
    }
  },
    "externalLaunch": {
        "document_title": "Harjutussessioon",
        "intro": {
            "title": "Harjutusvestlus",
            "lead": "Kohe räägite virtuaalse vestluspartneriga. Vestlus salvestatakse ja hinnatakse, tulemus jõuab tagasi Teie õppesüsteemi.",
            "requirements_title": "Mida on vaja",
            "requirement_mic": "Töötav mikrofon, eelistatavalt peakomplekt",
            "requirement_camera": "Kaamera ei ole kohustuslik, kuid sellega on vestlus loomulikum",
            "requirement_browser": "Arvuti värske Chrome, Edge või Safari brauseriga",
            "requirement_network": "Stabiilne internetiühendus ja vaikne koht, kus Teid ei segata",
            "start": "Alusta"
        },
        "relaunch_hint": "Minge tagasi oma õppesüsteemi ja avage materjal uuesti.",
        "saving": "Salvestame tulemust…",
        "review": {
            "document_title": "Sessiooni analüüs",
            "attempt": "Katse {number}",
            "result": {
                "passed": "Läbitud",
                "failed": "Läbimata",
                "pending": "Pole veel hinnatud"
            },
            "score_of_100": "{score} sajast",
            "threshold": "Läbimise lävi: {threshold}",
            "skills_title": "Oskused ja soovitused",
            "skills_empty": "Selle katse kohta pole veel oskuste kaupa tagasisidet.",
            "comments_title": "Kommentaarid salvestise kohta",
            "comments_empty": "Selle salvestise kohta pole kommentaare.",
            "loading": "Analüüs laaditakse",
            "error": {
                "not_found": {
                    "title": "Link ei tööta",
                    "text": "Analüüs ei ole enam saadaval: link on aegunud või katse võeti tagasi."
                },
                "expired": {
                    "title": "Leht on aegunud",
                    "text": "Avage analüüs uuesti oma õppesüsteemi lingi kaudu."
                },
                "generic": {
                    "title": "Analüüsi ei saa kuvada",
                    "text": "Meie poolel läks midagi valesti. Proovige linki uuesti avada."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Aitäh!",
                "text": "Vestlus on lõppenud. Tulemus ilmub Teie õppesüsteemi, kui analüüs on valmis. Selle lehe võite nüüd sulgeda."
            },
            "aborted": {
                "title": "Vestlus ei alanud",
                "text": "Enne vestluse algust läks midagi valesti."
            },
            "token_expired": {
                "title": "Sessioon on aegunud",
                "text": "Juurdepääs sellele vestlusele ei kehti enam."
            },
            "not_found": {
                "title": "Link ei tööta",
                "text": "Aadressis võib olla trükiviga või link ei kehti enam."
            },
            "rate_limited": {
                "title": "Liiga palju katseid",
                "text": "Oodake enne uut katset minut aega."
            },
            "generic": {
                "title": "Praegu ei saa alustada",
                "text": "Meie poolel läks midagi valesti."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Materjal on suletud",
                "text": "See materjal ei ole enam harjutamiseks saadaval."
            },
            "publication_draft": {
                "title": "Materjal ei ole veel avaldatud",
                "text": "Selle materjaliga harjutamist ei ole veel avatud."
            },
            "publication_expired": {
                "title": "Materjali tähtaeg on möödas",
                "text": "Aeg, mil selle materjaliga sai harjutada, on läbi."
            },
            "feature_disabled": {
                "title": "Materjal on suletud",
                "text": "Harjutamine õppesüsteemist on Teie organisatsiooni jaoks välja lülitatud."
            },
            "connection_disabled": {
                "title": "Materjal on suletud",
                "text": "Ühendus Teie õppesüsteemiga on välja lülitatud. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "launch_limit_reached": {
                "title": "Piir on täis",
                "text": "Selle materjaliga on juba peetud maksimaalne arv vestlusi."
            },
            "daily_budget_exhausted": {
                "title": "Tänaseks piisab",
                "text": "Olete saavutanud päevas lubatud vestluste arvu. Proovige homme uuesti."
            },
            "attempts_exhausted": {
                "title": "Katseid enam ei jää",
                "text": "Olete kasutanud kõik selle materjaliga lubatud katsed."
            },
            "quota_exhausted": {
                "title": "Praegu ei saa alustada",
                "text": "Teie organisatsioonil ei ole enam vestlusi järel. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "user_limit_reached": {
                "title": "Praegu ei saa alustada",
                "text": "Teie organisatsioonil ei ole enam vabu kohti. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "scenario_unavailable": {
                "title": "Materjal ei ole saadaval",
                "text": "Vestlust, mis selle materjali taga oli, enam ei ole."
            },
            "assignment_check_unavailable": {
                "title": "Praegu ei saa alustada",
                "text": "Me ei saanud kinnitada, et see materjal on Teile määratud. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "code_invalid": {
                "title": "Link ei kehti enam",
                "text": "Seda linki on juba kasutatud või selle aeg on läbi."
            },
            "channel_verification_failed": {
                "title": "Õppesüsteem ei vastanud",
                "text": "Me ei saanud Teie õppesüsteemis taotlust kinnitada."
            },
            "external_system_unavailable": {
                "title": "Õppesüsteem ei vasta",
                "text": "Me ei saanud õppesüsteemis kinnitada, et kursus on Teile määratud. Proovige mõne minuti pärast uuesti."
            },
            "user_not_found": {
                "title": "Me ei saanud Teid tuvastada",
                "text": "Teile ei ole siin veel kontot ja Teie organisatsioon ei loo neid automaatselt. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "user_unavailable": {
                "title": "Teie konto on välja lülitatud",
                "text": "Pöörduge selle poole, kes Teile kursuse määras."
            },
            "user_deleted": {
                "title": "Teie konto on kustutatud",
                "text": "Pöörduge selle poole, kes Teile kursuse määras."
            },
            "email_taken_linking_disabled": {
                "title": "Me ei saanud Teid tuvastada",
                "text": "Teie e-posti aadress kuulub siin juba teisele kontole. Pöörduge selle poole, kes Teile kursuse määras."
            },
            "service_role_not_allowed": {
                "title": "Selle kontoga ei saa harjutada",
                "text": "Administraatorikontod ei osale harjutusvestlustes. Kasutage oma õppijakontot."
            },
            "unverified_request": {
                "title": "Me ei saanud taotlust kinnitada",
                "text": "Teie õppesüsteem ei kinnitanud, et selle vestluse alustasite Teie."
            }
        },
        "manage": {
            "nav": {
                "group": "Väline käivitus",
                "publications": "Avaldused",
                "connections": "LMS-ühendused"
            },
            "messages": {
                "error": "Midagi läks valesti. Proovige uuesti.",
                "load_error": "Andmeid ei õnnestunud laadida."
            },
            "connections": {
                "title": "LMS-ühendused",
                "subtitle": "Õppesüsteemide kontod, millest see organisatsioon harjutusvestlusi käivitab.",
                "create": "Lisa ühendus",
                "edit": "Muuda",
                "set_credentials": "Määra juurdepääsuandmed",
                "empty": "Ühendusi pole veel.",
                "secret_missing": "Pole määratud",
                "no_expiry": "Ei aegu",
                "headers": {
                    "account": "Konto",
                    "base_url": "Aadress",
                    "client_id": "Kliendi tunnus",
                    "secret": "Saladus",
                    "status": "Olek",
                    "expires_at": "Juurdepääsuandmed aeguvad",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Juurdepääsuandmed puuduvad",
                    "active": "Aktiivne",
                    "expired": "Juurdepääsuandmed aegunud",
                    "disabled": "Väljalülitatud"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Uus ühendus",
                    "edit_title": "Ühendus",
                    "immutable_hint": "Õppesüsteemi ja kontot ei saa muuta: need määravad õppijate identiteediruumi. Teine konto tähendab uut ühendust.",
                    "lms_label": "Õppesüsteem",
                    "account_key_label": "Konto",
                    "account_key_hint": "Konto tunnus õppesüsteemis.",
                    "base_url_label": "iSpringi REST API aadress",
                    "base_url_hint": "Näiteks https://api-learn.ispringlearn.ru. See ei ole ettevõtte portaali aadress: siia saadetakse saladus.",
                    "base_url_https": "Aadress peab algama https://-ga",
                    "enabled_label": "Ühendus on sisse lülitatud",
                    "enabled_hint": "Ühendust ei kustutata kunagi — see lülitatakse välja. Avaldused ja käivitused jäävad nimekirjadesse, kuid uued käivitused lükatakse tagasi ja tulemused õppesüsteemi enam ei jõua.",
                    "credentials_optional": "Juurdepääsuandmed on valikulised. Ilma nendeta töötab ühendus piiratud režiimis.",
                    "client_id_label": "Kliendi tunnus",
                    "secret_label": "Saladus",
                    "secret_hint": "Salvestatakse krüpteeritult. Seda ei saa kunagi tagasi lugeda — näidatakse ainult viimast nelja tähemärki.",
                    "expires_at_label": "Juurdepääsuandmed aeguvad",
                    "expires_at_hint": "Jätke tühjaks, kui juurdepääsuandmed ei aegu."
                },
                "credentials_dialog": {
                    "title": "Juurdepääsuandmed",
                    "lead": "Uus saladus asendab eelmise. Ühendus säilitab oma tunnuse ning õppijate lingid ja käivitused jäävad muutumatuks.",
                    "secret_hint": "Eelmist saladust ei ole enam vaja ja seda ei saa tagasi lugeda."
                },
                "messages": {
                    "saved": "Ühendus salvestatud",
                    "credentials_saved": "Juurdepääsuandmed salvestatud"
                }
            },
            "publications": {
                "title": "Avaldused",
                "subtitle": "Stsenaariumid, mis on avatud käivitamiseks õppesüsteemist.",
                "create": "Uus avaldus",
                "edit": "Muuda",
                "enable": "Lülita sisse",
                "disable": "Lülita välja",
                "open_journal": "Logi",
                "download_package": "Laadi pakett alla",
                "empty": "Avaldusi pole veel.",
                "no_connections": "Õppesüsteemiga ühendust veel ei ole. Selle seab üles platvormi administraator.",
                "no_expiry": "Tähtaega pole",
                "attempts_unlimited": "Piiranguta",
                "immutable_hint": "Ühendust, stsenaariumi ja edastuskanalit ei saa muuta: need on sisse ehitatud paketti, mis on juba õppesüsteemi üles laaditud. Kõik muu rakendub ilma paketti uuesti üles ehitamata.",
                "headers": {
                    "scenario": "Stsenaarium",
                    "connection": "Ühendus",
                    "channel": "Kanal",
                    "status": "Olek",
                    "settings": "Seaded",
                    "expires_at": "Aegub",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Katseid: {value}",
                    "threshold": "Läbimise lävi: {value}"
                },
                "status": {
                    "draft": "Mustand",
                    "active": "Aktiivne",
                    "disabled": "Väljalülitatud"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Ainult olek",
                    "status_and_score": "Olek ja skoor",
                    "status_score_and_review": "Olek, skoor ja link analüüsile"
                },
                "warnings": {
                    "limited_mode": "Piiratud režiim: skoor ja tulemus ei jõua õppesüsteemi ning määramise kontrolli ei tehta.",
                    "connection_disabled": "Ühendus on välja lülitatud: selle avalduse kaudu käivitusi üldse ei aktsepteerita, kuni administraator ühenduse uuesti sisse lülitab.",
                    "assignment_check_off": "Kui lüliti on väljas, ei tuvastata kursuse ümbermääramist.",
                    "no_course_binding": "Avaldus ei ole kursusega seotud — skoor ei jõua õppesüsteemi."
                },
                "dialog": {
                    "connection_label": "Ühendus",
                    "scenario_label": "Stsenaarium",
                    "channel_label": "Edastuskanal",
                    "channel_hint": "Sisse ehitatud paketti ja hiljem ei saa seda muuta.",
                    "status_label": "Olek",
                    "status_hint": "Avaldust ei kustutata kunagi — see lülitatakse välja. Pärast seda lükatakse uued käivitused tagasi ja veel saatmata tulemused tühistatakse.",
                    "settings_section": "Katse seaded",
                    "attempts_label": "Katseid õppija kohta",
                    "attempts_unlimited": "Ilma piiranguta",
                    "daily_budget_label": "Käivitusi päevas õppija kohta",
                    "daily_budget_hint": "Kaitseb kvooti: iga alustatud vestlus arvatakse maha ega tule kunagi tagasi.",
                    "result_mode_label": "Mis läheb tagasi õppesüsteemi",
                    "pass_threshold_label": "Läbimise lävi, 0–100",
                    "result_wait_label": "Analüüsi ooteaeg, tundides",
                    "result_wait_hint": "Pärast seda annab käivitus teada „tulemust ei ole“.",
                    "launch_limit_label": "Käivituste koguarvu piir",
                    "launch_limit_hint": "Jätke tühjaks, kui piirangut ei ole.",
                    "assignment_check_label": "Kontrolli määramist õppesüsteemis",
                    "binding_section": "Sidumine õppesüsteemis",
                    "external_course_label": "Kursuse tunnus",
                    "external_item_label": "Elemendi tunnus",
                    "expires_label": "Avaldus aegub",
                    "expires_hint": "Jätke tühjaks, kui avaldusel tähtaega ei ole."
                },
                "key_dialog": {
                    "title": "Avaldus on loodud",
                    "warning": "Võti kuvatakse üks kord ja ainult siin. Seda ei saa mitte kusagilt tagasi lugeda — kopeerige see kohe ja sisestage paketi seadetesse. Kui see kaob, tuleb luua uus avaldus.",
                    "key_label": "Avalduse võti",
                    "copied": "Kopeeritud",
                    "package_hint": "Võti on juba paketi sees, nii et seda ei ole kuhugi vaja kleepida. Laadige pakett alla ja laadige see õppesüsteemi üles. Saate selle uuesti alla laadida igal ajal avalduste lehel."
                },
                "messages": {
                    "saved": "Avaldus salvestatud",
                    "enabled": "Avaldus sisse lülitatud",
                    "disabled": "Avaldus välja lülitatud",
                    "download_failed": "Paketti ei õnnestunud alla laadida. Värskendage lehte ja proovige uuesti."
                }
            },
            "journal": {
                "title": "Käivituste logi",
                "unknown_scenario": "Stsenaarium pole saadaval",
                "back": "Avalduste juurde",
                "revoke": "Võta katse tagasi",
                "revoke_confirm": "Võtta see katse tagasi? Õppija kaotab juurdepääsu vestlusele ja saatmata jäänud edastused tühistatakse.",
                "retry_delivery": "Proovi uuesti",
                "empty_launches": "Käivitusi pole veel.",
                "empty_events": "Sündmusi pole veel.",
                "no_deliveries": "Sellel katsel edastusi ei ole.",
                "not_held_quota_charged": "Ei toimunud, kvoot maha arvatud",
                "relaunches": "taaskäivitusi: {value}",
                "last_launch": "viimane käivitus: {value}",
                "result_deadline": "Oodatakse analüüsi kuni {value}",
                "learner_contacts": "Õppesüsteemi saadetud aadress: {email}. Käivitatud aadressilt: {ip}",
                "score_passed": "{value} — läbitud",
                "score_failed": "{value} — läbimata",
                "tabs": {
                    "launches": "Katsed",
                    "events": "Sündmused"
                },
                "headers": {
                    "learner": "Õppija",
                    "user": "Konto",
                    "attempt": "Katse",
                    "status": "Olek",
                    "game": "Vestlus",
                    "started_at": "Alustatud",
                    "actions": " ",
                    "event_type": "Sündmus",
                    "refusal": "Põhjus",
                    "request_proof": "Taotluse tõend",
                    "ip": "Aadress",
                    "user_agent": "Klient",
                    "happened_at": "Millal"
                },
                "launch_status": {
                    "created": "Link väljastatud",
                    "started": "Käib",
                    "not_held": "Ei toimunud",
                    "awaiting_result": "Ootab analüüsi",
                    "result_ready": "Tulemus edastatud",
                    "evaluation_failed": "Analüüsi pole",
                    "result_timed_out": "Ooteaeg lõppes",
                    "assignment_changed": "Määramine muutus",
                    "revoked": "Tagasi võetud"
                },
                "delivery": {
                    "version": "Versioon",
                    "status": "Olek",
                    "outcome": "Väljund",
                    "result": "Tulemus",
                    "score": "Skoor",
                    "attempts": "Katsed",
                    "last_attempt": "Viimane katse",
                    "external_state": "Olek õppesüsteemis"
                },
                "delivery_status": {
                    "pending": "Järjekorras",
                    "in_progress": "Saadetakse",
                    "done": "Valmis",
                    "needs_attention": "Vajab tähelepanu"
                },
                "delivery_outcome": {
                    "accepted": "Vastu võetud",
                    "confirmed": "Kinnitatud",
                    "rejected_by_external": "Tagasi lükatud",
                    "retry": "Kordus planeeritud",
                    "cancelled": "Tühistatud",
                    "assignment_changed": "Määramine muutus"
                },
                "result": {
                    "passed": "Läbitud",
                    "failed": "Läbimata",
                    "not_held": "Ei toimunud",
                    "no_result": "Tulemust pole"
                },
                "refusal": {
                    "publication_disabled": "Avaldus välja lülitatud",
                    "publication_draft": "Avaldus on mustand",
                    "publication_expired": "Avalduse tähtaeg möödas",
                    "feature_disabled": "Väline käivitus välja lülitatud",
                    "connection_disabled": "Ühendus välja lülitatud",
                    "launch_limit_reached": "Käivituste piir täis",
                    "daily_budget_exhausted": "Päevaeelarve otsas",
                    "attempts_exhausted": "Katsed otsas",
                    "quota_exhausted": "Organisatsiooni kvoot otsas",
                    "user_limit_reached": "Vabu kohti pole",
                    "scenario_unavailable": "Stsenaarium pole saadaval",
                    "assignment_check_unavailable": "Määramise kontroll pole saadaval",
                    "code_invalid": "Link juba kasutatud või aegunud",
                    "channel_verification_failed": "Õppesüsteem ei kinnitanud taotlust",
                    "external_system_unavailable": "Õppesüsteem ei vastanud määramise kontrollile",
                    "user_not_found": "Õppijal pole kontot",
                    "user_unavailable": "Õppija konto välja lülitatud",
                    "user_deleted": "Õppija konto kustutatud",
                    "email_taken_linking_disabled": "E-post kuulub teisele kontole",
                    "service_role_not_allowed": "Teenusekonto ei saa harjutada",
                    "unverified_request": "Taotlust ei kinnitatud"
                },
                "event_type": {
                    "launch_refused": "Käivitus tagasi lükatud",
                    "exchange_refused": "Link tagasi lükatud",
                    "exchange_succeeded": "Link kasutatud"
                },
                "request_proof": {
                    "unverified": "Kinnitamata",
                    "assignment_verified": "Määramine kinnitatud"
                },
                "messages": {
                    "retry_queued": "Kordus järjekorras",
                    "revoked": "Katse tagasi võetud"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Harjutus",
            "interview": "Intervjuu"
        },
        "load": {
            "loading": "Sessiooni laadimine…",
            "failed": "Sessiooni laadimine ebaõnnestus. Kontrollige ühendust ja proovige uuesti.",
            "scenarioFailed": "Stsenaariumi laadimine ebaõnnestus",
            "scenarioRetry": "Proovi uuesti"
        },
        "leave": {
            "confirm": "Vestlus käib endiselt. Lehelt lahkumine seda ei lõpeta ning aeg jookseb edasi. Kas lahkuda leheküljelt?",
            "confirmEnd": "Vestlus käib endiselt. Kui lahkute, see lõpeb ja seda hinnatakse selle põhjal, mida jõudsite käsitleda. Kas lahkuda?"
        },
        "elsewhere": {
            "interviewTitle": "Intervjuu on avatud teises vahelehes",
            "interviewText": "Intervjuu käib teises vahelehes või teises seadmes. Jätkake seal — selle vahelehe võite sulgeda.",
            "conversationTitle": "Vestlus on avatud teises vahelehes",
            "conversationText": "Vestlus käib teises vahelehes või teises seadmes. Jätkake seal — selle vahelehe võite sulgeda."
        },
        "prep": {
            "header": {
                "backToSessions": "Sessioonide juurde",
                "themeToggleAriaLabel": "Vaheta teemat"
            },
            "scenario": {
                "sectionLabel": "Stsenaarium",
                "competenceLabel": "Hinnatav kompetents",
                "gameNumber": "Sessioon #{number}",
                "duration": "{minutes} min",
                "readFull": "Loe tervikuna",
                "generalLabel": "Üldine teave",
                "playerLabel": "Teave teile"
            },
            "selfCamera": {
                "previewLabel": "Teie kaamera eelvaade",
                "off": "Kaamera on väljas"
            },
            "notes": {
                "empty": "Tühi"
            },
            "start": {
                "button": "Alusta sessiooni",
                "interviewButton": "Alusta intervjuud",
                "resumeButton": "Tagasi vestlusesse",
                "resumeHint": "Vestlus juba käib — aeg jookseb edasi."
            }
        },
        "equipment": {
            "status": {
                "checking": "Seadmete kontrollimine",
                "waiting": "Loa ootamine",
                "denied": "Juurdepääs keelatud",
                "busy": "Seade on hõivatud",
                "noCamera": "Kaamerat pole",
                "missing": "Mikrofoni pole",
                "dismissed": "Juurdepääsu ei antud",
                "ready": "Seadmed on valmis"
            },
            "checking": {
                "title": "Kontrollime Teie mikrofoni ja kaamerat…"
            },
            "waiting": {
                "title": "Lubage juurdepääs mikrofonile",
                "cameraTitle": "Lubage juurdepääs kaamerale",
                "description": "Brauseri loasoov on juba avatud. Ilma mikrofonita ei saa vestlust alustada."
            },
            "denied": {
                "title": "Brauser blokeerib mikrofoni",
                "cameraTitle": "Brauser blokeerib kaamerat",
                "description": "Brauser jättis blokeeringu meelde. Lubage mikrofonile juurdepääs saidi seadetes ja värskendage lehte.",
                "cameraDescription": "Brauser jättis blokeeringu meelde. Lubage kaamerale juurdepääs saidi seadetes ja värskendage lehte.",
                "showInstructions": "Näita, kuidas",
                "hideInstructions": "Peida",
                "chromeEdge": {
                    "browser": "Chrome ja Edge",
                    "text": "Klõpsake aadressiriba vasakul asuval lukuikoonil, avage \"Saidi seaded\", lubage \"Mikrofon\" ja värskendage lehte."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Avage Safari menüü → \"Selle veebisaidi seaded\", lubage \"Mikrofon\" ja värskendage lehte."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Klõpsake aadressiribal mikrofoniikoonil, eemaldage selle saidi blokeering ja värskendage lehte."
                },
                "system": {
                    "title": "Teie süsteem blokeerib brauseri juurdepääsu mikrofonile",
                    "cameraTitle": "Teie süsteem blokeerib brauseri juurdepääsu kaamerale",
                    "macos": "macOS: Süsteemi seaded → Privaatsus ja turvalisus → Mikrofon (või Kaamera) → lülitage brauser sisse ja taaskäivitage see.",
                    "windows": "Windows: Seaded → Privaatsus ja turvalisus → Mikrofon (või Kaamera) → lubage juurdepääs rakendustele ja brauserile, seejärel vajutage \"Proovi uuesti\"."
                }
            },
            "busy": {
                "title": "Mikrofoni kasutab mõni teine rakendus",
                "cameraTitle": "Kaamerat kasutab mõni teine rakendus",
                "description": "Tavaliselt on see taustale jäänud kõne. Sulgege see ja vajutage \"Proovi uuesti\".",
                "retry": "Proovi uuesti"
            },
            "noCamera": {
                "title": "Kaamerat pole",
                "description": "Teid on kuulda, kuid mitte näha.",
                "requiredByScenario": "See vestlus nõuab kaamerat. Jätkamiseks ühendage see."
            },
            "missing": {
                "title": "Mikrofoni ei leitud",
                "description": "Ühendage mikrofon ja vajutage \"Proovi uuesti\". Ilma selleta ei saa vestlust alustada."
            },
            "dismissed": {
                "title": "Mikrofonile juurdepääsu ei antud",
                "cameraTitle": "Kaamerale juurdepääsu ei antud",
                "description": "Brauseriaken suleti ilma vastuseta. Vajutage \"Proovi uuesti\" ja lubage juurdepääs."
            },
            "ready": {
                "title": "Seadmed on valmis"
            },
            "micLabel": "Mikrofon",
            "cameraLabel": "Kaamera",
            "chooseMic": "Vali mikrofon",
            "chooseCamera": "Vali kaamera",
            "micLevelHint": "Öelge midagi",
            "speakerValue": "Kõlar: {name}",
            "configure": "Seadista",
            "dialog": {
                "title": "Seadmed",
                "lockedDuringConversation": "Vestluse ajal ei saa seadmeid muuta.",
                "micSelectLabel": "Mikrofon",
                "cameraSelectLabel": "Kaamera",
                "speakerSelectLabel": "Kõlar",
                "noCameraOption": "Kaamerata",
                "record": "Salvesta 3 sekundit",
                "recording": "Salvestamine…",
                "recordFailed": "Salvestamine ebaõnnestus. Proovige uuesti.",
                "listen": "Kuula",
                "playing": "Esitamine…",
                "done": "Valmis",
                "closeAriaLabel": "Sulge dialoog"
            },
            "unnamed": {
                "microphone": "Mikrofon {number}",
                "camera": "Kaamera {number}",
                "speaker": "Kõlar {number}"
            },
            "cameraWarmup": {
                "preview": "Kaamera lülitub sisse",
                "title": "Mikrofon on valmis",
                "description": "Kaamera jõuab järele – tavaliselt ühe-kahe sekundiga.",
                "slowHint": "Kaamera ei lülitu sisse? Valige jaotises „Seadista“ mõni teine."
            }
        },
        "recording": {
            "videoAndAudio": "Vestlust ja videot salvestatakse.",
            "audioOnly": "Vestlust salvestatakse.",
            "accessSelfAndEvaluators": "Salvestis on kättesaadav Teile ja neile, kes hindavad Teie tööd.",
            "accessEvaluators": "Salvestis on kättesaadav neile, kes hindavad Teie tööd."
        },
        "scenario": {
            "video": "Stsenaariumi autori video"
        },
        "notes": {
            "title": "Sessiooni märkmed",
            "placeholder": "Mida soovite harjutada, milliseid fraase olete ette valmistanud",
            "saving": "Salvestame…",
            "saved": "Salvestatud",
            "saveError": "Salvestamine ebaõnnestus",
            "visibility": "Märkmed on nähtavad Teile ja neile, kes hindavad sessiooni.",
            "unsupported": "Need märkmed sisaldavad elemente, mida siin ei saa muuta. Need on säilinud muutmata kujul."
        },
        "stage": {
            "agentState": {
                "speaking": "Räägib",
                "listening": "Kuulab",
                "thinking": "Mõtleb"
            },
            "micOffWarning": "Mikrofon on väljas — vestluspartner Teid ei kuule",
            "micOnAriaLabel": "Lülita mikrofon välja",
            "micOffAriaLabel": "Lülita mikrofon sisse",
            "micOff": "Mikrofon väljas",
            "micOnAnnouncement": "Mikrofon sees",
            "captionsLabel": "Subtiitrid",
            "captionsOnAriaLabel": "Peida subtiitrid",
            "captionsOffAriaLabel": "Näita subtiitreid",
            "talkBalance": {
                "title": "Kõnetasakaal",
                "you": "Teie",
                "interlocutor": "Vestluspartner"
            },
            "connectionQuality": {
                "excellent": "Suurepärane ühendus",
                "good": "Hea ühendus",
                "poor": "Nõrk ühendus",
                "unknown": "Ühenduse kvaliteet teadmata"
            },
            "selfCameraLabel": "Teie",
            "timeWarning": {
                "lastMinute": "Jäänud on üks minut — aeg lõpetada",
                "finalSeconds": "15 sekundit — lõpetage oma mõte"
            },
            "timeUp": {
                "title": "Aeg on läbi",
                "text": "Vestlus sulgub iseenesest, seda ei saa pikendada.",
                "closing": "Suleme vestlust…"
            },
            "voiceOnly": "Häälrežiim — sellel stsenaariumil videot ei ole",
            "interlocutorConnecting": {
                "title": "Vestluspartner ühendub",
                "hint": "Tavaliselt 2–4 sekundit"
            },
            "layout": {
                "label": "Kõrvuti",
                "sideTitle": "Paiguta kõrvuti",
                "focusTitle": "Suurenda vestluspartner"
            }
        },
        "panels": {
            "scenario": "Stsenaarium",
            "transcript": "Transkriptsioon",
            "transcriptEmpty": "Siia ilmuvad lõpetatud repliigid.",
            "notes": "Märkmed",
            "characterMemoryTab": "Mida tegelane mäletab",
            "openAriaLabel": "Ava paneel \"{panel}\"",
            "closeAriaLabel": "Sulge paneel \"{panel}\""
        },
        "sound": {
            "label": "Heli",
            "volumeLabel": "Helitugevus",
            "speakerLabel": "Kõlar"
        },
        "end": {
            "button": "Lõpeta",
            "confirmTitle": "Kas lõpetada vestlus?",
            "elapsed": "Möödas {elapsed} {total}-st.",
            "partialEvaluationNotice": "Vestlust hinnatakse selle põhjal, mida jõudsite käsitleda.",
            "continue": "Jätka",
            "notSent": "Vestlus lõpeb aja täitumisel: server ei vastanud lõpetamispäringule."
        },
        "wait": {
            "title": "Valmistame vestlust ette",
            "hint": "See võtab tavaliselt 1–3 minutit. Ärge sulgege lehte — alustame automaatselt.",
            "nextTry": "Järgmine katse {time} pärast",
            "trying": "Proovime alustada…",
            "retrying": "Veel ei õnnestunud. Proovime uuesti {time} pärast",
            "cancel": "Tühista",
            "failed": {
                "title": "Vestlust ei õnnestunud alustada",
                "text": "Praegu pole vabu kohti. Mikrofoni ja kaamera seaded on salvestatud — proovige mõne minuti pärast uuesti.",
                "retry": "Proovi uuesti"
            }
        },
        "connection": {
            "reconnecting": "Ühendus katkes, ühendume uuesti…",
            "restored": "Ühendus taastatud",
            "failed": "Ühenduse taastamine ebaõnnestus",
            "retry": "Proovi uuesti"
        },
        "hotkeys": {
            "title": "Klaviatuuri kiirklahvid",
            "showHintAriaLabel": "Näita klaviatuuri kiirklahve",
            "micToggle": "Mikrofoni sisse/välja lülitamine",
            "scenarioPanel": "Stsenaarium: paneeli avamine ja sulgemine",
            "transcriptPanel": "Transkriptsioon",
            "notesPanel": "Märkmed",
            "captionsToggle": "Subtiitrite sisse/välja lülitamine",
            "closeTopLayer": "Paneeli, hüpikakna või dialoogi sulgemine",
            "endConfirm": "Lõpeta — avab kinnituse",
            "showHint": "Näita seda vihjet"
        },
        "intro": {
            "candidate": {
                "greeting": "Tere, {name}!",
                "leadWithVacancy": "{organization} kutsub Teid intervjuule virtuaalse vestluspartneriga vakantsi «{vacancy}» jaoks.",
                "duration": "Intervjuu kestab umbes {minutes} min.",
                "requirementsTitle": "Mida on vaja",
                "requirementMic": "Töötav mikrofon, eelistatavalt peakomplekt",
                "requirementCameraRequired": "Sisselülitatud kaamera: selle intervjuu jaoks on see kohustuslik",
                "requirementCameraOptional": "Kaamera ei ole kohustuslik, kuid sellega on vestlus loomulikum",
                "requirementBrowser": "Arvuti värske Chrome, Edge või Safari brauseriga",
                "requirementNetwork": "Stabiilne internetiühendus ja vaikne koht, kus Teid ei segata",
                "consentTextLabel": "Nõusoleku tekst",
                "consentAccept": "Olen tekstiga tutvunud ja annan nõusoleku oma isikuandmete töötlemiseks",
                "next": "Edasi"
            },
            "launch": {
                "title": "Harjutusvestlus",
                "lead": "Kohe räägite virtuaalse vestluspartneriga. Vestlus salvestatakse ja hinnatakse, tulemus jõuab tagasi Teie õppesüsteemi.",
                "requirementsTitle": "Mida on vaja",
                "requirementMic": "Töötav mikrofon, eelistatavalt peakomplekt",
                "requirementCamera": "Kaamera ei ole kohustuslik, kuid sellega muutub vestlus elavamaks",
                "requirementBrowser": "Arvuti värske Chrome, Edge või Safari brauseriga",
                "requirementNetwork": "Stabiilne internetiühendus ja vaikne koht, kus Teid ei segata",
                "start": "Alusta"
            }
        },
        "finished": {
            "candidate": {
                "title": "Täname!",
                "text": "Intervjuu on lõppenud. Tulemus jõuab värbajani, kes võtab Teiega ühendust. Selle lehe võite nüüd sulgeda."
            },
            "launch": {
                "title": "Täname!",
                "text": "Vestlus on lõppenud. Tulemus ilmub Teie õppesüsteemi, kui hinnang on valmis. Selle lehe võite nüüd sulgeda."
            }
        },
        "closeDialogAriaLabel": "Sulge dialoog"
    },
    "loopAvatars": {
        "title": "Tsükliavatarid",
        "upload": "Laadi avatar üles",
        "newVersion": "Uus versioon",
        "newVersionHint": "„{name}“, praegune versioon {version}. Uus pakett asendab videod kõigis selle avatariga profiilides.",
        "edit": "Muuda avatari",
        "delete": "Kustuta avatar",
        "empty": "Avatare pole veel",
        "headers": {
            "poster": "Plakat",
            "name": "Nimi",
            "gender": "Sugu",
            "emotion": "Emotsioon",
            "visibility": "Nähtavus",
            "version": "Versioon",
            "profiles": "Profiilid"
        },
        "gender": {
            "male": "Mees",
            "female": "Naine"
        },
        "emotion": {
            "calm": "Rahulik",
            "friendly": "Sõbralik",
            "strict": "Range"
        },
        "visibility": {
            "all": "Kõik organisatsioonid"
        },
        "fields": {
            "package": "Avatari pakett (.zip)"
        },
        "packageHint": "ZIP kuni 100 MB, milles on manifest.json, listen.mp4, talk.mp4, transitions.json ja poster.jpg",
        "validation": {
            "packageTooLarge": "Pakett ei tohi ületada 100 MB"
        },
        "errors": {
            "requestFailed": "Päring ebaõnnestus. Proovige uuesti."
        },
        "confirmDetach": "Lahti seotavaid profiile: {count}. Need lülituvad fotole. Salvestada?",
        "confirmDelete": "Kustutada avatar „{name}“?",
        "confirmDeleteWithProfiles": "Avatari „{name}“ kasutatakse profiilides: {count}. Need lülituvad fotole. Kustutada?"
    },
    "ttsVoices": {
        "title": "TTS-hääled",
        "create": "Lisa hääl",
        "edit": "Muuda häält",
        "delete": "Kustuta hääl",
        "replaceSample": "Asenda näidis",
        "replaceSampleHint": "„{name}“, praegune näidise versioon {version}. Uus näidis kõlab kõigis selle häälega profiilides.",
        "empty": "Hääli pole veel",
        "play": "Kuula näidist",
        "stop": "Peata",
        "headers": {
            "name": "Nimi",
            "provider": "Pakkuja",
            "externalId": "Hääle ID",
            "gender": "Sugu",
            "languages": "Keeled",
            "visibility": "Nähtavus",
            "sample": "Näidis",
            "profiles": "Profiilid"
        },
        "gender": {
            "male": "Mees",
            "female": "Naine"
        },
        "visibility": {
            "all": "Kõik organisatsioonid"
        },
        "fields": {
            "sample": "Hääle näidis",
            "speed": "Kõnekiirus"
        },
        "sampleHint": "MP3, MP4 või M4A kuni 5 MB",
        "sampleOptionalHint": "Valikuline — näidis luuakse häälega selle ID järgi. MP3, MP4 või M4A kuni 5 MB",
        "synthesizeSample": "Loo uuesti",
        "speedChangedHint": "Uue kiiruse kuulmiseks looge hääle näidis uuesti.",
        "speedSamplePromptTitle": "Kiirus muudetud",
        "speedSamplePrompt": "Näidis kõlab endiselt eelmise kiirusega. Kas loote selle uuesti? Praegune näidis asendatakse.",
        "saveAndSynthesize": "Salvesta ja loo",
        "saveOnly": "Ainult salvesta",
        "validation": {
            "sampleTooLarge": "Näidis ei tohi ületada 5 MB"
        },
        "errors": {
            "requestFailed": "Päring ebaõnnestus. Proovige uuesti.",
            "sampleUnavailable": "Näidist ei õnnestunud esitada"
        },
        "confirmDetach": "Lahti seotavaid profiile: {count}. Need lülituvad ühenduse häälele. Salvestada?",
        "confirmDelete": "Kustutada hääl „{name}“?",
        "confirmDeleteWithProfiles": "Häält „{name}“ kasutatakse profiilides: {count}. Need lülituvad ühenduse häälele. Kustutada?",
        "picker": {
            "none": "Vaikehääl",
            "empty": "Kataloogis pole selle soo hääli",
            "loadError": "Hääli ei õnnestunud laadida",
            "playSample": "Kuula näidist: {name}",
            "stopSample": "Peata näidis: {name}",
            "sampleUnavailable": "Näidis pole saadaval"
        }
    },
    "realtimeAvatars": {
        "title": "Live-avatarid",
        "create": "Lisa avatar",
        "edit": "Muuda avatari",
        "delete": "Kustuta avatar",
        "preview": "Vaata eelvaadet",
        "empty": "Avatare veel pole",
        "headers": {
            "poster": "Plakat",
            "name": "Nimi",
            "provider": "Teenusepakkuja",
            "externalId": "Avatari ID",
            "gender": "Sugu",
            "visibility": "Nähtavus",
            "profiles": "Profiilid",
            "models": "Anam-i mudelid"
        },
        "gender": {
            "male": "Mees",
            "female": "Naine"
        },
        "visibility": {
            "all": "Kõik organisatsioonid"
        },
        "nameHint": "Valikuline — kasutatakse nime teenusest Anam",
        "externalIdHint": "Kui muudate ID-d, laaditakse plakat ja eelvaade teenusest Anam uuesti",
        "errors": {
            "requestFailed": "Päring ebaõnnestus. Proovige uuesti.",
            "previewUnavailable": "Eelvaadet ei õnnestunud esitada"
        },
        "confirmDetach": "Lahtiseotavaid profiile: {count}. Need lülituvad fotole. Salvestada?",
        "confirmDelete": "Kustutada avatar „{name}“?",
        "confirmDeleteWithProfiles": "Avatar „{name}“ on kasutusel profiilides: {count}. Need lülituvad fotole. Kustutada?",
        "picker": {
            "label": "Live-avatarid",
            "empty": "Sellele profiilile pole Live-avatare saadaval",
            "emptyFiltered": "Selle soo Live-avatare pole",
            "loadError": "Live-avatare ei õnnestunud laadida"
        }
    },
    "aiProfileAppearance": {
        "label": "Välimus",
        "photo": "Oma foto",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Maskott",
        "filterGender": "Sugu",
        "filterEmotion": "Emotsioon",
        "avatarsLabel": "Avatarid",
        "avatarRequired": "Valige avatar",
        "liveRequired": "Valige Live-avatar",
        "livePlaceholder": "Teie Live-avatar ilmub siia",
        "empty": "Sellele profiilile pole avatare saadaval",
        "emptyFiltered": "Ükski avatar ei vasta filtritele",
        "loadError": "Avatare ei õnnestunud laadida",
        "playPreview": "Esita eelvaade: {name}",
        "pausePreview": "Peata eelvaade: {name}"
    },
  "emailStopList": {
    "title": "E-posti stopp-nimekiri",
    "description": "Nendele aadressidele ja domeenidele e-kirju ei saadeta. Domeeni kirje katab kõik selle domeeni aadressid, kuid mitte selle alamdomeene.",
    "searchPlaceholder": "Otsi aadressi või domeeni järgi",
    "allReasons": "Kõik põhjused",
    "add": "Lisa",
    "addTitle": "Blokeeri aadress või domeen",
    "empty": "Stopp-nimekiri on tühi",
    "editNote": "Muuda märkust",
    "headers": {
      "type": "Tüüp",
      "value": "Aadress või domeen",
      "reason": "Põhjus",
      "providerReply": "E-posti teenuse vastus",
      "note": "Märkus",
      "author": "Lisaja",
      "createdAt": "Lisamise kuupäev",
      "blockedCount": "Peatatud kirju",
      "lastBlockedAt": "Viimati peatatud"
    },
    "type": {
      "address": "Aadress",
      "domain": "Domeen"
    },
    "reason": {
      "manual": "Lisatud käsitsi",
      "providerRejected": "E-posti teenus lükkas tagasi"
    },
    "author": {
      "system": "Süsteem"
    },
    "fields": {
      "value": "Aadress või domeen",
      "valueHint": "Sisesta täielik aadress või ainult domeen. Domeen blokeerib kõik selle aadressid, kuid mitte alamdomeene.",
      "note": "Märkus"
    },
    "errors": {
      "requestFailed": "Midagi läks valesti. Proovi uuesti."
    },
    "unblock": {
      "action": "Eemalda blokeering",
      "confirm": "Kas eemaldada blokeering: {value}?",
      "resultTitle": "Blokeeringu eemaldamise tulemus",
      "result": {
        "removedEverywhere": "Blokeering eemaldatud. E-posti teenuse stopp-nimekirjas seda aadressi pole, seega kirju saadetakse taas.",
        "removedLocally": "Domeeni blokeering eemaldatud. Selle domeeni aadressid, millel on oma kirje, jäävad blokeerituks.",
        "providerNotConfigured": "Eemaldati ainult platvormi kirje: ühendus e-posti teenusega pole seadistatud, seega selle stopp-nimekirja ei kontrollitud.",
        "providerUnavailable": "E-posti teenus ei ole saadaval, proovi hiljem uuesti. Aadress on endiselt blokeeritud.",
        "stillListedAtProvider": "Aadress on e-posti teenuse stopp-nimekirjas. Eemalda see teenuse paneelis ja vajuta „Eemalda blokeering uuesti“. Kui paneelis aadressi ei näidata, on see teenuse globaalses stopp-nimekirjas ja sealt seda eemaldada ei saa."
      },
      "openPanel": "Ava e-posti teenuse paneel",
      "panelPath": "Kust eemaldada: e-posti teenuse paneel → Products → Email Service → sinu ressurss → vaheleht Stop Lists.",
      "retry": "Eemalda blokeering uuesti"
    },
    "suggestions": {
      "text": "Domeenis {domain} on blokeeritud aadresse: {count}. Kas blokeerida kogu domeen?",
      "block": "Blokeeri domeen",
      "confirm": "Kas blokeerida domeen {domain}? Kirjade saatmine kõigile selle aadressidele lõpetatakse. Alamdomeene see ei mõjuta ja üksikute aadresside kirjed jäävad alles."
    },
    "check": {
      "title": "Kontrolli aadressi",
      "hint": "Näitab, kas kirjad sellele aadressile blokeerib platvorm või e-posti teenus",
      "placeholder": "E-posti aadress",
      "submit": "Kontrolli",
      "resultFor": "Tulemus aadressile {email}",
      "platform": "Platvormi stopp-nimekiri",
      "platformListed": "Jah — kirje „{value}“",
      "provider": "E-posti teenuse stopp-nimekiri",
      "listed": "Jah",
      "notListed": "Ei",
      "providerReasons": "E-posti teenuse esitatud põhjused:",
      "providerNotConfigured": "Ühendus e-posti teenusega pole seadistatud",
      "providerUnavailable": "E-posti teenus ei ole saadaval, proovi hiljem uuesti"
    }
  }
}
